import de from 'vee-validate/dist/locale/de'
import en from 'vee-validate/dist/locale/en'
import { Validator } from 'vee-validate'
import { getCookieValue } from '../utils'
import { setAxiosHeaderAcceptLang } from '../utils/axios'

export const GLOBAL_MIXIN = {
  data() {
    return {
      $userEmail: localStorage.getItem('userEmail'),
      $userType: localStorage.getItem('userType'),
      authToken: localStorage.getItem('_verificationToken'),
      $isRecruiter: localStorage.getItem('userType') === 'Recruiter',
      $isCandidate: localStorage.getItem('userType') === 'Candidate',
      $isAdmin: localStorage.getItem('userType') === 'User',
      currentLanguage: '',
      defaultProfilePic: '/assets/img/default-pic.png',
      defaultCompanyPic: '/assets/img/default-company-logo.png',
      faceMode: true,
      metruPhoneNo: '0221 89 99 42 54',
      landscapeContraints: {
        audio: { echoCancellation: true },
        video: {
          width: { ideal: 1280 },
          height: { ideal: 720 },
          facingMode: 'user',
          aspectRatio: {
            min: 16 / 9,
          },
        },
      },
      portraitConstraints: {
        audio: { echoCancellation: true },
        video: {
          width: { ideal: 720 },
          height: { ideal: 1280 },
          facingMode: 'user',
          aspectRatio: {
            min: 9 / 16,
          },
        },
      },
    }
  },
  mounted() {
    this.$userType = localStorage.getItem('userType')
    this.$userEmail = localStorage.getItem('userEmail')
    this.authToken = localStorage.getItem('_verificationToken')
    this.$isRecruiter = localStorage.getItem('userType') === 'Recruiter'
    this.$isCandidate = localStorage.getItem('userType') === 'Candidate'
    this.$isAdmin = localStorage.getItem('userType') === 'User'
    this.applyCIStyles()
  },
  computed: {
    // Replace this dumbass code
    $activePage: function () {
      const pathname = this.$route.path.split('/')
      return pathname[pathname.length - 1]
    },
    $currentPath: function () {
      return this.$route.path
    },
    $employeeNumberRange: function () {
      return [
        this.$i18n.translate('1-9 Employees'),
        this.$i18n.translate('10-49 Employees'),
        this.$i18n.translate('50-99 Employees'),
        this.$i18n.translate('100-249 Employees'),
        this.$i18n.translate('250-499 Employees'),
        this.$i18n.translate('> 500 Employees'),
      ]
    },
    $employmentTypes: function () {
      return [
        {
          label: this.$i18n.translate('Full Time'),
          value: 'Full Time',
        },
        {
          label: this.$i18n.translate('Part Time'),
          value: 'Part Time',
        },
        {
          label: this.$i18n.translate('Temporary Appointment'),
          value: 'Temporary Appointment',
        },
        {
          label: this.$i18n.translate('Internship'),
          value: 'Internship',
        },
        {
          label: this.$i18n.translate('Permanent Employment'),
          value: 'Permanent Employment',
        },
        {
          label: this.$i18n.translate('Apprenticeship'),
          value: 'Apprenticeship',
        },
        {
          label: this.$i18n.translate('Contract for work'),
          value: 'Contract for work',
        },
        {
          label: this.$i18n.translate('Freelance'),
          value: 'Freelance',
        },
      ]
    },
    $fieldsOfActivity: function () {
      return [
        this.$i18n.translate('Administration/processing'),
        this.$i18n.translate('Education and training'),
        this.$i18n.translate('Customer service/customer care'),
        this.$i18n.translate('Design and layout'),
        this.$i18n.translate('Management/strategic management'),
        this.$i18n.translate('Craft trades'),
        this.$i18n.translate('Hotel and catering'),
        this.$i18n.translate('Engineering/development and construction'),
        this.$i18n.translate('Maintenance'),
        this.$i18n.translate('IT information technology'),
        this.$i18n.translate('Logistics and Transport'),
        this.$i18n.translate('Marketing'),
        this.$i18n.translate('Medicine and Health'),
        this.$i18n.translate('Scientific Research'),
        this.$i18n.translate('Human Resources'),
        this.$i18n.translate('Production'),
        this.$i18n.translate('Project Management'),
        this.$i18n.translate('Quality Management'),
        this.$i18n.translate('Accounting/Finance'),
        this.$i18n.translate('Law'),
        this.$i18n.translate('Editorial/Documentation'),
        this.$i18n.translate('Security/Civil Protection'),
        this.$i18n.translate('Distribution/Sales'),
        this.$i18n.translate('Other Professions'),
      ]
    },
    $countriesReduced: function () {
      return [
        {
          label: this.$i18n.translate('Afghanistan'),
          value: 'Afghanistan',
        },
        {
          label: this.$i18n.translate('Åland Islands'),
          value: 'Åland Islands',
        },
        {
          label: this.$i18n.translate('Albania'),
          value: 'Albania',
        },
        {
          label: this.$i18n.translate('Algeria'),
          value: 'Algeria',
        },
        {
          label: this.$i18n.translate('American Samoa'),
          value: 'American Samoa',
        },
        {
          label: this.$i18n.translate('Andorra'),
          value: 'Andorra',
        },
        {
          label: this.$i18n.translate('Angola'),
          value: 'Angola',
        },
        {
          label: this.$i18n.translate('Anguilla'),
          value: 'Anguilla',
        },
        {
          label: this.$i18n.translate('Antarctica'),
          value: 'Antarctica',
        },
        {
          label: this.$i18n.translate('Antigua and Barbuda'),
          value: 'Antigua and Barbuda',
        },
        {
          label: this.$i18n.translate('Argentina'),
          value: 'Argentina',
        },
        {
          label: this.$i18n.translate('Armenia'),
          value: 'Armenia',
        },
        {
          label: this.$i18n.translate('Aruba'),
          value: 'Aruba',
        },
        {
          label: this.$i18n.translate('Australia'),
          value: 'Australia',
        },
        {
          label: this.$i18n.translate('Austria'),
          value: 'Austria',
        },
        {
          label: this.$i18n.translate('Azerbaijan'),
          value: 'Azerbaijan',
        },
        {
          label: this.$i18n.translate('Bahamas'),
          value: 'Bahamas',
        },
        {
          label: this.$i18n.translate('Bahrain'),
          value: 'Bahrain',
        },
        {
          label: this.$i18n.translate('Bangladesh'),
          value: 'Bangladesh',
        },
        {
          label: this.$i18n.translate('Barbados'),
          value: 'Barbados',
        },
        {
          label: this.$i18n.translate('Belarus'),
          value: 'Belarus',
        },
        {
          label: this.$i18n.translate('Belgium'),
          value: 'Belgium',
        },
        {
          label: this.$i18n.translate('Belize'),
          value: 'Belize',
        },
        {
          label: this.$i18n.translate('Benin'),
          value: 'Benin',
        },
        {
          label: this.$i18n.translate('Bermuda'),
          value: 'Bermuda',
        },
        {
          label: this.$i18n.translate('Bhutan'),
          value: 'Bhutan',
        },
        {
          label: this.$i18n.translate('Bolivia'),
          value: 'Bolivia',
        },
        {
          label: this.$i18n.translate('Bosnia and Herzegovina'),
          value: 'Bosnia and Herzegovina',
        },
        {
          label: this.$i18n.translate('Botswana'),
          value: 'Botswana',
        },
        {
          label: this.$i18n.translate('Bouvet Island'),
          value: 'Bouvet Island',
        },
        {
          label: this.$i18n.translate('Brazil'),
          value: 'Brazil',
        },
        {
          label: this.$i18n.translate('British Indian Ocean Territory'),
          value: 'British Indian Ocean Territory',
        },
        {
          label: this.$i18n.translate('British Virgin Islands'),
          value: 'British Virgin Islands',
        },
        {
          label: this.$i18n.translate('Brunei'),
          value: 'Brunei',
        },
        {
          label: this.$i18n.translate('Bulgaria'),
          value: 'Bulgaria',
        },
        {
          label: this.$i18n.translate('Burkina Faso'),
          value: 'Burkina Faso',
        },
        {
          label: this.$i18n.translate('Burundi'),
          value: 'Burundi',
        },
        {
          label: this.$i18n.translate('Cambodia'),
          value: 'Cambodia',
        },
        {
          label: this.$i18n.translate('Cameroon'),
          value: 'Cameroon',
        },
        {
          label: this.$i18n.translate('Canada'),
          value: 'Canada',
        },
        {
          label: this.$i18n.translate('Cape Verde'),
          value: 'Cape Verde',
        },
        {
          label: this.$i18n.translate('Caribbean Netherlands'),
          value: 'Caribbean Netherlands',
        },
        {
          label: this.$i18n.translate('Cayman Islands'),
          value: 'Cayman Islands',
        },
        {
          label: this.$i18n.translate('Central African Republic'),
          value: 'Central African Republic',
        },
        {
          label: this.$i18n.translate('Chad'),
          value: 'Chad',
        },
        {
          label: this.$i18n.translate('Chile'),
          value: 'Chile',
        },
        {
          label: this.$i18n.translate('China'),
          value: 'China',
        },
        {
          label: this.$i18n.translate('Christmas Island'),
          value: 'Christmas Island',
        },
        {
          label: this.$i18n.translate('Cocos (Keeling) Islands'),
          value: 'Cocos (Keeling) Islands',
        },
        {
          label: this.$i18n.translate('Colombia'),
          value: 'Colombia',
        },
        {
          label: this.$i18n.translate('Comoros'),
          value: 'Comoros',
        },
        {
          label: this.$i18n.translate('Cook Islands'),
          value: 'Cook Islands',
        },
        {
          label: this.$i18n.translate('Costa Rica'),
          value: 'Costa Rica',
        },
        {
          label: this.$i18n.translate('Croatia'),
          value: 'Croatia',
        },
        {
          label: this.$i18n.translate('Cuba'),
          value: 'Cuba',
        },
        {
          label: this.$i18n.translate('Curaçao'),
          value: 'Curaçao',
        },
        {
          label: this.$i18n.translate('Cyprus'),
          value: 'Cyprus',
        },
        {
          label: this.$i18n.translate('Czechia'),
          value: 'Czechia',
        },
        {
          label: this.$i18n.translate('Denmark'),
          value: 'Denmark',
        },
        {
          label: this.$i18n.translate('Djibouti'),
          value: 'Djibouti',
        },
        {
          label: this.$i18n.translate('Dominica'),
          value: 'Dominica',
        },
        {
          label: this.$i18n.translate('Dominican Republic'),
          value: 'Dominican Republic',
        },
        {
          label: this.$i18n.translate('DR Congo'),
          value: 'DR Congo',
        },
        {
          label: this.$i18n.translate('Ecuador'),
          value: 'Ecuador',
        },
        {
          label: this.$i18n.translate('Egypt'),
          value: 'Egypt',
        },
        {
          label: this.$i18n.translate('El Salvador'),
          value: 'El Salvador',
        },
        {
          label: this.$i18n.translate('Equatorial Guinea'),
          value: 'Equatorial Guinea',
        },
        {
          label: this.$i18n.translate('Eritrea'),
          value: 'Eritrea',
        },
        {
          label: this.$i18n.translate('Estonia'),
          value: 'Estonia',
        },
        {
          label: this.$i18n.translate('Eswatini'),
          value: 'Eswatini',
        },
        {
          label: this.$i18n.translate('Ethiopia'),
          value: 'Ethiopia',
        },
        {
          label: this.$i18n.translate('Falkland Islands'),
          value: 'Falkland Islands',
        },
        {
          label: this.$i18n.translate('Faroe Islands'),
          value: 'Faroe Islands',
        },
        {
          label: this.$i18n.translate('Fiji'),
          value: 'Fiji',
        },
        {
          label: this.$i18n.translate('Finland'),
          value: 'Finland',
        },
        {
          label: this.$i18n.translate('France'),
          value: 'France',
        },
        {
          label: this.$i18n.translate('French Guiana'),
          value: 'French Guiana',
        },
        {
          label: this.$i18n.translate('French Polynesia'),
          value: 'French Polynesia',
        },
        {
          label: this.$i18n.translate('French Southern and Antarctic Lands'),
          value: 'French Southern and Antarctic Lands',
        },
        {
          label: this.$i18n.translate('Gabon'),
          value: 'Gabon',
        },
        {
          label: this.$i18n.translate('Gambia'),
          value: 'Gambia',
        },
        {
          label: this.$i18n.translate('Georgia'),
          value: 'Georgia',
        },
        {
          label: this.$i18n.translate('Germany'),
          value: 'Germany',
        },
        {
          label: this.$i18n.translate('Ghana'),
          value: 'Ghana',
        },
        {
          label: this.$i18n.translate('Gibraltar'),
          value: 'Gibraltar',
        },
        {
          label: this.$i18n.translate('Greece'),
          value: 'Greece',
        },
        {
          label: this.$i18n.translate('Greenland'),
          value: 'Greenland',
        },
        {
          label: this.$i18n.translate('Grenada'),
          value: 'Grenada',
        },
        {
          label: this.$i18n.translate('Guadeloupe'),
          value: 'Guadeloupe',
        },
        {
          label: this.$i18n.translate('Guam'),
          value: 'Guam',
        },
        {
          label: this.$i18n.translate('Guatemala'),
          value: 'Guatemala',
        },
        {
          label: this.$i18n.translate('Guernsey'),
          value: 'Guernsey',
        },
        {
          label: this.$i18n.translate('Guinea'),
          value: 'Guinea',
        },
        {
          label: this.$i18n.translate('Guinea-Bissau'),
          value: 'Guinea-Bissau',
        },
        {
          label: this.$i18n.translate('Guyana'),
          value: 'Guyana',
        },
        {
          label: this.$i18n.translate('Haiti'),
          value: 'Haiti',
        },
        {
          label: this.$i18n.translate('Heard Island and McDonald Islands'),
          value: 'Heard Island and McDonald Islands',
        },
        {
          label: this.$i18n.translate('Honduras'),
          value: 'Honduras',
        },
        {
          label: this.$i18n.translate('Hong Kong'),
          value: 'Hong Kong',
        },
        {
          label: this.$i18n.translate('Hungary'),
          value: 'Hungary',
        },
        {
          label: this.$i18n.translate('Iceland'),
          value: 'Iceland',
        },
        {
          label: this.$i18n.translate('India'),
          value: 'India',
        },
        {
          label: this.$i18n.translate('Indonesia'),
          value: 'Indonesia',
        },
        {
          label: this.$i18n.translate('Iran'),
          value: 'Iran',
        },
        {
          label: this.$i18n.translate('Iraq'),
          value: 'Iraq',
        },
        {
          label: this.$i18n.translate('Ireland'),
          value: 'Ireland',
        },
        {
          label: this.$i18n.translate('Isle of Man'),
          value: 'Isle of Man',
        },
        {
          label: this.$i18n.translate('Israel'),
          value: 'Israel',
        },
        {
          label: this.$i18n.translate('Italy'),
          value: 'Italy',
        },
        {
          label: this.$i18n.translate('Ivory Coast'),
          value: 'Ivory Coast',
        },
        {
          label: this.$i18n.translate('Jamaica'),
          value: 'Jamaica',
        },
        {
          label: this.$i18n.translate('Japan'),
          value: 'Japan',
        },
        {
          label: this.$i18n.translate('Jersey'),
          value: 'Jersey',
        },
        {
          label: this.$i18n.translate('Jordan'),
          value: 'Jordan',
        },
        {
          label: this.$i18n.translate('Kazakhstan'),
          value: 'Kazakhstan',
        },
        {
          label: this.$i18n.translate('Kenya'),
          value: 'Kenya',
        },
        {
          label: this.$i18n.translate('Kiribati'),
          value: 'Kiribati',
        },
        {
          label: this.$i18n.translate('Kosovo'),
          value: 'Kosovo',
        },
        {
          label: this.$i18n.translate('Kuwait'),
          value: 'Kuwait',
        },
        {
          label: this.$i18n.translate('Kyrgyzstan'),
          value: 'Kyrgyzstan',
        },
        {
          label: this.$i18n.translate('Laos'),
          value: 'Laos',
        },
        {
          label: this.$i18n.translate('Latvia'),
          value: 'Latvia',
        },
        {
          label: this.$i18n.translate('Lebanon'),
          value: 'Lebanon',
        },
        {
          label: this.$i18n.translate('Lesotho'),
          value: 'Lesotho',
        },
        {
          label: this.$i18n.translate('Liberia'),
          value: 'Liberia',
        },
        {
          label: this.$i18n.translate('Libya'),
          value: 'Libya',
        },
        {
          label: this.$i18n.translate('Liechtenstein'),
          value: 'Liechtenstein',
        },
        {
          label: this.$i18n.translate('Lithuania'),
          value: 'Lithuania',
        },
        {
          label: this.$i18n.translate('Luxembourg'),
          value: 'Luxembourg',
        },
        {
          label: this.$i18n.translate('Macau'),
          value: 'Macau',
        },
        {
          label: this.$i18n.translate('Madagascar'),
          value: 'Madagascar',
        },
        {
          label: this.$i18n.translate('Malawi'),
          value: 'Malawi',
        },
        {
          label: this.$i18n.translate('Malaysia'),
          value: 'Malaysia',
        },
        {
          label: this.$i18n.translate('Maldives'),
          value: 'Maldives',
        },
        {
          label: this.$i18n.translate('Mali'),
          value: 'Mali',
        },
        {
          label: this.$i18n.translate('Malta'),
          value: 'Malta',
        },
        {
          label: this.$i18n.translate('Marshall Islands'),
          value: 'Marshall Islands',
        },
        {
          label: this.$i18n.translate('Martinique'),
          value: 'Martinique',
        },
        {
          label: this.$i18n.translate('Mauritania'),
          value: 'Mauritania',
        },
        {
          label: this.$i18n.translate('Mauritius'),
          value: 'Mauritius',
        },
        {
          label: this.$i18n.translate('Mayotte'),
          value: 'Mayotte',
        },
        {
          label: this.$i18n.translate('Mexico'),
          value: 'Mexico',
        },
        {
          label: this.$i18n.translate('Micronesia'),
          value: 'Micronesia',
        },
        {
          label: this.$i18n.translate('Moldova'),
          value: 'Moldova',
        },
        {
          label: this.$i18n.translate('Monaco'),
          value: 'Monaco',
        },
        {
          label: this.$i18n.translate('Mongolia'),
          value: 'Mongolia',
        },
        {
          label: this.$i18n.translate('Montenegro'),
          value: 'Montenegro',
        },
        {
          label: this.$i18n.translate('Montserrat'),
          value: 'Montserrat',
        },
        {
          label: this.$i18n.translate('Morocco'),
          value: 'Morocco',
        },
        {
          label: this.$i18n.translate('Mozambique'),
          value: 'Mozambique',
        },
        {
          label: this.$i18n.translate('Myanmar'),
          value: 'Myanmar',
        },
        {
          label: this.$i18n.translate('Namibia'),
          value: 'Namibia',
        },
        {
          label: this.$i18n.translate('Nauru'),
          value: 'Nauru',
        },
        {
          label: this.$i18n.translate('Nepal'),
          value: 'Nepal',
        },
        {
          label: this.$i18n.translate('Netherlands'),
          value: 'Netherlands',
        },
        {
          label: this.$i18n.translate('New Caledonia'),
          value: 'New Caledonia',
        },
        {
          label: this.$i18n.translate('New Zealand'),
          value: 'New Zealand',
        },
        {
          label: this.$i18n.translate('Nicaragua'),
          value: 'Nicaragua',
        },
        {
          label: this.$i18n.translate('Niger'),
          value: 'Niger',
        },
        {
          label: this.$i18n.translate('Nigeria'),
          value: 'Nigeria',
        },
        {
          label: this.$i18n.translate('Niue'),
          value: 'Niue',
        },
        {
          label: this.$i18n.translate('Norfolk Island'),
          value: 'Norfolk Island',
        },
        {
          label: this.$i18n.translate('North Korea'),
          value: 'North Korea',
        },
        {
          label: this.$i18n.translate('North Macedonia'),
          value: 'North Macedonia',
        },
        {
          label: this.$i18n.translate('Northern Mariana Islands'),
          value: 'Northern Mariana Islands',
        },
        {
          label: this.$i18n.translate('Norway'),
          value: 'Norway',
        },
        {
          label: this.$i18n.translate('Oman'),
          value: 'Oman',
        },
        {
          label: this.$i18n.translate('Pakistan'),
          value: 'Pakistan',
        },
        {
          label: this.$i18n.translate('Palau'),
          value: 'Palau',
        },
        {
          label: this.$i18n.translate('Palestine'),
          value: 'Palestine',
        },
        {
          label: this.$i18n.translate('Panama'),
          value: 'Panama',
        },
        {
          label: this.$i18n.translate('Papua New Guinea'),
          value: 'Papua New Guinea',
        },
        {
          label: this.$i18n.translate('Paraguay'),
          value: 'Paraguay',
        },
        {
          label: this.$i18n.translate('Peru'),
          value: 'Peru',
        },
        {
          label: this.$i18n.translate('Philippines'),
          value: 'Philippines',
        },
        {
          label: this.$i18n.translate('Pitcairn Islands'),
          value: 'Pitcairn Islands',
        },
        {
          label: this.$i18n.translate('Poland'),
          value: 'Poland',
        },
        {
          label: this.$i18n.translate('Portugal'),
          value: 'Portugal',
        },
        {
          label: this.$i18n.translate('Puerto Rico'),
          value: 'Puerto Rico',
        },
        {
          label: this.$i18n.translate('Qatar'),
          value: 'Qatar',
        },
        {
          label: this.$i18n.translate('Republic of the Congo'),
          value: 'Republic of the Congo',
        },
        {
          label: this.$i18n.translate('Réunion'),
          value: 'Réunion',
        },
        {
          label: this.$i18n.translate('Romania'),
          value: 'Romania',
        },
        {
          label: this.$i18n.translate('Russia'),
          value: 'Russia',
        },
        {
          label: this.$i18n.translate('Rwanda'),
          value: 'Rwanda',
        },
        {
          label: this.$i18n.translate('Saint Barthélemy'),
          value: 'Saint Barthélemy',
        },
        {
          label: this.$i18n.translate('Saint Helena, Ascension and Tristan da Cunha'),
          value: 'Saint Helena, Ascension and Tristan da Cunha',
        },
        {
          label: this.$i18n.translate('Saint Kitts and Nevis'),
          value: 'Saint Kitts and Nevis',
        },
        {
          label: this.$i18n.translate('Saint Lucia'),
          value: 'Saint Lucia',
        },
        {
          label: this.$i18n.translate('Saint Martin'),
          value: 'Saint Martin',
        },
        {
          label: this.$i18n.translate('Saint Pierre and Miquelon'),
          value: 'Saint Pierre and Miquelon',
        },
        {
          label: this.$i18n.translate('Saint Vincent and the Grenadines'),
          value: 'Saint Vincent and the Grenadines',
        },
        {
          label: this.$i18n.translate('Samoa'),
          value: 'Samoa',
        },
        {
          label: this.$i18n.translate('San Marino'),
          value: 'San Marino',
        },
        {
          label: this.$i18n.translate('São Tomé and Príncipe'),
          value: 'São Tomé and Príncipe',
        },
        {
          label: this.$i18n.translate('Saudi Arabia'),
          value: 'Saudi Arabia',
        },
        {
          label: this.$i18n.translate('Senegal'),
          value: 'Senegal',
        },
        {
          label: this.$i18n.translate('Serbia'),
          value: 'Serbia',
        },
        {
          label: this.$i18n.translate('Seychelles'),
          value: 'Seychelles',
        },
        {
          label: this.$i18n.translate('Sierra Leone'),
          value: 'Sierra Leone',
        },
        {
          label: this.$i18n.translate('Singapore'),
          value: 'Singapore',
        },
        {
          label: this.$i18n.translate('Sint Maarten'),
          value: 'Sint Maarten',
        },
        {
          label: this.$i18n.translate('Slovakia'),
          value: 'Slovakia',
        },
        {
          label: this.$i18n.translate('Slovenia'),
          value: 'Slovenia',
        },
        {
          label: this.$i18n.translate('Solomon Islands'),
          value: 'Solomon Islands',
        },
        {
          label: this.$i18n.translate('Somalia'),
          value: 'Somalia',
        },
        {
          label: this.$i18n.translate('South Africa'),
          value: 'South Africa',
        },
        {
          label: this.$i18n.translate('South Georgia'),
          value: 'South Georgia',
        },
        {
          label: this.$i18n.translate('South Korea'),
          value: 'South Korea',
        },
        {
          label: this.$i18n.translate('South Sudan'),
          value: 'South Sudan',
        },
        {
          label: this.$i18n.translate('Spain'),
          value: 'Spain',
        },
        {
          label: this.$i18n.translate('Sri Lanka'),
          value: 'Sri Lanka',
        },
        {
          label: this.$i18n.translate('Sudan'),
          value: 'Sudan',
        },
        {
          label: this.$i18n.translate('Suriname'),
          value: 'Suriname',
        },
        {
          label: this.$i18n.translate('Svalbard and Jan Mayen'),
          value: 'Svalbard and Jan Mayen',
        },
        {
          label: this.$i18n.translate('Sweden'),
          value: 'Sweden',
        },
        {
          label: this.$i18n.translate('Switzerland'),
          value: 'Switzerland',
        },
        {
          label: this.$i18n.translate('Syria'),
          value: 'Syria',
        },
        {
          label: this.$i18n.translate('Taiwan'),
          value: 'Taiwan',
        },
        {
          label: this.$i18n.translate('Tajikistan'),
          value: 'Tajikistan',
        },
        {
          label: this.$i18n.translate('Tanzania'),
          value: 'Tanzania',
        },
        {
          label: this.$i18n.translate('Thailand'),
          value: 'Thailand',
        },
        {
          label: this.$i18n.translate('Timor-Leste'),
          value: 'Timor-Leste',
        },
        {
          label: this.$i18n.translate('Togo'),
          value: 'Togo',
        },
        {
          label: this.$i18n.translate('Tokelau'),
          value: 'Tokelau',
        },
        {
          label: this.$i18n.translate('Tonga'),
          value: 'Tonga',
        },
        {
          label: this.$i18n.translate('Trinidad and Tobago'),
          value: 'Trinidad and Tobago',
        },
        {
          label: this.$i18n.translate('Tunisia'),
          value: 'Tunisia',
        },
        {
          label: this.$i18n.translate('Turkey'),
          value: 'Turkey',
        },
        {
          label: this.$i18n.translate('Turkmenistan'),
          value: 'Turkmenistan',
        },
        {
          label: this.$i18n.translate('Turks and Caicos Islands'),
          value: 'Turks and Caicos Islands',
        },
        {
          label: this.$i18n.translate('Tuvalu'),
          value: 'Tuvalu',
        },
        {
          label: this.$i18n.translate('Uganda'),
          value: 'Uganda',
        },
        {
          label: this.$i18n.translate('Ukraine'),
          value: 'Ukraine',
        },
        {
          label: this.$i18n.translate('United Arab Emirates'),
          value: 'United Arab Emirates',
        },
        {
          label: this.$i18n.translate('United Kingdom'),
          value: 'United Kingdom',
        },
        {
          label: this.$i18n.translate('United States'),
          value: 'United States',
        },
        {
          label: this.$i18n.translate('United States Minor Outlying Islands'),
          value: 'United States Minor Outlying Islands',
        },
        {
          label: this.$i18n.translate('United States Virgin Islands'),
          value: 'United States Virgin Islands',
        },
        {
          label: this.$i18n.translate('Uruguay'),
          value: 'Uruguay',
        },
        {
          label: this.$i18n.translate('Uzbekistan'),
          value: 'Uzbekistan',
        },
        {
          label: this.$i18n.translate('Vanuatu'),
          value: 'Vanuatu',
        },
        {
          label: this.$i18n.translate('Vatican City'),
          value: 'Vatican City',
        },
        {
          label: this.$i18n.translate('Venezuela'),
          value: 'Venezuela',
        },
        {
          label: this.$i18n.translate('Vietnam'),
          value: 'Vietnam',
        },
        {
          label: this.$i18n.translate('Wallis and Futuna'),
          value: 'Wallis and Futuna',
        },
        {
          label: this.$i18n.translate('Western Sahara'),
          value: 'Western Sahara',
        },
        {
          label: this.$i18n.translate('Yemen'),
          value: 'Yemen',
        },
        {
          label: this.$i18n.translate('Zambia'),
          value: 'Zambia',
        },
        {
          label: this.$i18n.translate('Zimbabwe'),
          value: 'Zimbabwe',
        },
      ]
    },
    $countries: function () {
      return [
        {
          name: 'Afghanistan',
          code: 'AF',
        },
        {
          name: 'Albania',
          code: 'AL',
        },
        {
          name: 'Algeria',
          code: 'DZ',
        },
        {
          name: 'American Samoa',
          code: 'AS',
        },
        {
          name: 'AndorrA',
          code: 'AD',
        },
        {
          name: 'Angola',
          code: 'AO',
        },
        {
          name: 'Anguilla',
          code: 'AI',
        },
        {
          name: 'Antarctica',
          code: 'AQ',
        },
        {
          name: 'Antigua and Barbuda',
          code: 'AG',
        },
        {
          name: 'Argentina',
          code: 'AR',
        },
        {
          name: 'Armenia',
          code: 'AM',
        },
        {
          name: 'Aruba',
          code: 'AW',
        },
        {
          name: 'Australia',
          code: 'AU',
        },
        {
          name: 'Austria',
          code: 'AT',
        },
        {
          name: 'Azerbaijan',
          code: 'AZ',
        },
        {
          name: 'Bahamas',
          code: 'BS',
        },
        {
          name: 'Bahrain',
          code: 'BH',
        },
        {
          name: 'Bangladesh',
          code: 'BD',
        },
        {
          name: 'Barbados',
          code: 'BB',
        },
        {
          name: 'Belarus',
          code: 'BY',
        },
        {
          name: 'Belgium',
          code: 'BE',
        },
        {
          name: 'Belize',
          code: 'BZ',
        },
        {
          name: 'Benin',
          code: 'BJ',
        },
        {
          name: 'Bermuda',
          code: 'BM',
        },
        {
          name: 'Bhutan',
          code: 'BT',
        },
        {
          name: 'Bolivia',
          code: 'BO',
        },
        {
          name: 'Bosnia and Herzegovina',
          code: 'BA',
        },
        {
          name: 'Botswana',
          code: 'BW',
        },
        {
          name: 'Bouvet Island',
          code: 'BV',
        },
        {
          name: 'Brazil',
          code: 'BR',
        },
        {
          name: 'British Indian Ocean Territory',
          code: 'IO',
        },
        {
          name: 'Brunei Darussalam',
          code: 'BN',
        },
        {
          name: 'Bulgaria',
          code: 'BG',
        },
        {
          name: 'Burkina Faso',
          code: 'BF',
        },
        {
          name: 'Burundi',
          code: 'BI',
        },
        {
          name: 'Cambodia',
          code: 'KH',
        },
        {
          name: 'Cameroon',
          code: 'CM',
        },
        {
          name: 'Canada',
          code: 'CA',
        },
        {
          name: 'Cape Verde',
          code: 'CV',
        },
        {
          name: 'Cayman Islands',
          code: 'KY',
        },
        {
          name: 'Central African Republic',
          code: 'CF',
        },
        {
          name: 'Chad',
          code: 'TD',
        },
        {
          name: 'Chile',
          code: 'CL',
        },
        {
          name: 'China',
          code: 'CN',
        },
        {
          name: 'Christmas Island',
          code: 'CX',
        },
        {
          name: 'Cocos (Keeling) Islands',
          code: 'CC',
        },
        {
          name: 'Colombia',
          code: 'CO',
        },
        {
          name: 'Comoros',
          code: 'KM',
        },
        {
          name: 'Congo',
          code: 'CG',
        },
        {
          name: 'Congo, The Democratic Republic of the',
          code: 'CD',
        },
        {
          name: 'Cook Islands',
          code: 'CK',
        },
        {
          name: 'Costa Rica',
          code: 'CR',
        },
        {
          name: "Cote D'Ivoire",
          code: 'CI',
        },
        {
          name: 'Croatia',
          code: 'HR',
        },
        {
          name: 'Cuba',
          code: 'CU',
        },
        {
          name: 'Cyprus',
          code: 'CY',
        },
        {
          name: 'Czech Republic',
          code: 'CZ',
        },
        {
          name: 'Denmark',
          code: 'DK',
        },
        {
          name: 'Djibouti',
          code: 'DJ',
        },
        {
          name: 'Dominica',
          code: 'DM',
        },
        {
          name: 'Dominican Republic',
          code: 'DO',
        },
        {
          name: 'Ecuador',
          code: 'EC',
        },
        {
          name: 'Egypt',
          code: 'EG',
        },
        {
          name: 'El Salvador',
          code: 'SV',
        },
        {
          name: 'Equatorial Guinea',
          code: 'GQ',
        },
        {
          name: 'Eritrea',
          code: 'ER',
        },
        {
          name: 'Estonia',
          code: 'EE',
        },
        {
          name: 'Ethiopia',
          code: 'ET',
        },
        {
          name: 'Falkland Islands (Malvinas)',
          code: 'FK',
        },
        {
          name: 'Faroe Islands',
          code: 'FO',
        },
        {
          name: 'Fiji',
          code: 'FJ',
        },
        {
          name: 'Finland',
          code: 'FI',
        },
        {
          name: 'France',
          code: 'FR',
        },
        {
          name: 'French Guiana',
          code: 'GF',
        },
        {
          name: 'French Polynesia',
          code: 'PF',
        },
        {
          name: 'French Southern Territories',
          code: 'TF',
        },
        {
          name: 'Gabon',
          code: 'GA',
        },
        {
          name: 'Gambia',
          code: 'GM',
        },
        {
          name: 'Georgia',
          code: 'GE',
        },
        {
          name: 'Germany',
          code: 'DE',
        },
        {
          name: 'Ghana',
          code: 'GH',
        },
        {
          name: 'Gibraltar',
          code: 'GI',
        },
        {
          name: 'Greece',
          code: 'GR',
        },
        {
          name: 'Greenland',
          code: 'GL',
        },
        {
          name: 'Grenada',
          code: 'GD',
        },
        {
          name: 'Guadeloupe',
          code: 'GP',
        },
        {
          name: 'Guam',
          code: 'GU',
        },
        {
          name: 'Guatemala',
          code: 'GT',
        },
        {
          name: 'Guernsey',
          code: 'GG',
        },
        {
          name: 'Guinea',
          code: 'GN',
        },
        {
          name: 'Guinea-Bissau',
          code: 'GW',
        },
        {
          name: 'Guyana',
          code: 'GY',
        },
        {
          name: 'Haiti',
          code: 'HT',
        },
        {
          name: 'Heard Island and Mcdonald Islands',
          code: 'HM',
        },
        {
          name: 'Holy See (Vatican City State)',
          code: 'VA',
        },
        {
          name: 'Honduras',
          code: 'HN',
        },
        {
          name: 'Hong Kong',
          code: 'HK',
        },
        {
          name: 'Hungary',
          code: 'HU',
        },
        {
          name: 'Iceland',
          code: 'IS',
        },
        {
          name: 'India',
          code: 'IN',
        },
        {
          name: 'Indonesia',
          code: 'ID',
        },
        {
          name: 'Iran, Islamic Republic Of',
          code: 'IR',
        },
        {
          name: 'Iraq',
          code: 'IQ',
        },
        {
          name: 'Ireland',
          code: 'IE',
        },
        {
          name: 'Isle of Man',
          code: 'IM',
        },
        {
          name: 'Israel',
          code: 'IL',
        },
        {
          name: 'Italy',
          code: 'IT',
        },
        {
          name: 'Jamaica',
          code: 'JM',
        },
        {
          name: 'Japan',
          code: 'JP',
        },
        {
          name: 'Jersey',
          code: 'JE',
        },
        {
          name: 'Jordan',
          code: 'JO',
        },
        {
          name: 'Kazakhstan',
          code: 'KZ',
        },
        {
          name: 'Kenya',
          code: 'KE',
        },
        {
          name: 'Kiribati',
          code: 'KI',
        },
        {
          name: "Korea, Democratic People'S Republic of",
          code: 'KP',
        },
        {
          name: 'Korea, Republic of',
          code: 'KR',
        },
        {
          name: 'Kuwait',
          code: 'KW',
        },
        {
          name: 'Kyrgyzstan',
          code: 'KG',
        },
        {
          name: 'land Islands',
          code: 'AX',
        },
        {
          name: "Lao People'S Democratic Republic",
          code: 'LA',
        },
        {
          name: 'Latvia',
          code: 'LV',
        },
        {
          name: 'Lebanon',
          code: 'LB',
        },
        {
          name: 'Lesotho',
          code: 'LS',
        },
        {
          name: 'Liberia',
          code: 'LR',
        },
        {
          name: 'Libyan Arab Jamahiriya',
          code: 'LY',
        },
        {
          name: 'Liechtenstein',
          code: 'LI',
        },
        {
          name: 'Lithuania',
          code: 'LT',
        },
        {
          name: 'Luxembourg',
          code: 'LU',
        },
        {
          name: 'Macao',
          code: 'MO',
        },
        {
          name: 'Macedonia, The Former Yugoslav Republic of',
          code: 'MK',
        },
        {
          name: 'Madagascar',
          code: 'MG',
        },
        {
          name: 'Malawi',
          code: 'MW',
        },
        {
          name: 'Malaysia',
          code: 'MY',
        },
        {
          name: 'Maldives',
          code: 'MV',
        },
        {
          name: 'Mali',
          code: 'ML',
        },
        {
          name: 'Malta',
          code: 'MT',
        },
        {
          name: 'Marshall Islands',
          code: 'MH',
        },
        {
          name: 'Martinique',
          code: 'MQ',
        },
        {
          name: 'Mauritania',
          code: 'MR',
        },
        {
          name: 'Mauritius',
          code: 'MU',
        },
        {
          name: 'Mayotte',
          code: 'YT',
        },
        {
          name: 'Mexico',
          code: 'MX',
        },
        {
          name: 'Micronesia, Federated States of',
          code: 'FM',
        },
        {
          name: 'Moldova, Republic of',
          code: 'MD',
        },
        {
          name: 'Monaco',
          code: 'MC',
        },
        {
          name: 'Mongolia',
          code: 'MN',
        },
        {
          name: 'Montenegro',
          code: 'ME',
        },
        {
          name: 'Montserrat',
          code: 'MS',
        },
        {
          name: 'Morocco',
          code: 'MA',
        },
        {
          name: 'Mozambique',
          code: 'MZ',
        },
        {
          name: 'Myanmar',
          code: 'MM',
        },
        {
          name: 'Namibia',
          code: 'NA',
        },
        {
          name: 'Nauru',
          code: 'NR',
        },
        {
          name: 'Nepal',
          code: 'NP',
        },
        {
          name: 'Netherlands',
          code: 'NL',
        },
        {
          name: 'Netherlands Antilles',
          code: 'AN',
        },
        {
          name: 'New Caledonia',
          code: 'NC',
        },
        {
          name: 'New Zealand',
          code: 'NZ',
        },
        {
          name: 'Nicaragua',
          code: 'NI',
        },
        {
          name: 'Niger',
          code: 'NE',
        },
        {
          name: 'Nigeria',
          code: 'NG',
        },
        {
          name: 'Niue',
          code: 'NU',
        },
        {
          name: 'Norfolk Island',
          code: 'NF',
        },
        {
          name: 'Northern Mariana Islands',
          code: 'MP',
        },
        {
          name: 'Norway',
          code: 'NO',
        },
        {
          name: 'Oman',
          code: 'OM',
        },
        {
          name: 'Pakistan',
          code: 'PK',
        },
        {
          name: 'Palau',
          code: 'PW',
        },
        {
          name: 'Palestinian Territory, Occupied',
          code: 'PS',
        },
        {
          name: 'Panama',
          code: 'PA',
        },
        {
          name: 'Papua New Guinea',
          code: 'PG',
        },
        {
          name: 'Paraguay',
          code: 'PY',
        },
        {
          name: 'Peru',
          code: 'PE',
        },
        {
          name: 'Philippines',
          code: 'PH',
        },
        {
          name: 'Pitcairn',
          code: 'PN',
        },
        {
          name: 'Poland',
          code: 'PL',
        },
        {
          name: 'Portugal',
          code: 'PT',
        },
        {
          name: 'Puerto Rico',
          code: 'PR',
        },
        {
          name: 'Qatar',
          code: 'QA',
        },
        {
          name: 'Reunion',
          code: 'RE',
        },
        {
          name: 'Romania',
          code: 'RO',
        },
        {
          name: 'Russian Federation',
          code: 'RU',
        },
        {
          name: 'RWANDA',
          code: 'RW',
        },
        {
          name: 'Saint Helena',
          code: 'SH',
        },
        {
          name: 'Saint Kitts and Nevis',
          code: 'KN',
        },
        {
          name: 'Saint Lucia',
          code: 'LC',
        },
        {
          name: 'Saint Pierre and Miquelon',
          code: 'PM',
        },
        {
          name: 'Saint Vincent and the Grenadines',
          code: 'VC',
        },
        {
          name: 'Samoa',
          code: 'WS',
        },
        {
          name: 'San Marino',
          code: 'SM',
        },
        {
          name: 'Sao Tome and Principe',
          code: 'ST',
        },
        {
          name: 'Saudi Arabia',
          code: 'SA',
        },
        {
          name: 'Senegal',
          code: 'SN',
        },
        {
          name: 'Serbia',
          code: 'RS',
        },
        {
          name: 'Seychelles',
          code: 'SC',
        },
        {
          name: 'Sierra Leone',
          code: 'SL',
        },
        {
          name: 'Singapore',
          code: 'SG',
        },
        {
          name: 'Slovakia',
          code: 'SK',
        },
        {
          name: 'Slovenia',
          code: 'SI',
        },
        {
          name: 'Solomon Islands',
          code: 'SB',
        },
        {
          name: 'Somalia',
          code: 'SO',
        },
        {
          name: 'South Africa',
          code: 'ZA',
        },
        {
          name: 'South Georgia and the South Sandwich Islands',
          code: 'GS',
        },
        {
          name: 'Spain',
          code: 'ES',
        },
        {
          name: 'Sri Lanka',
          code: 'LK',
        },
        {
          name: 'Sudan',
          code: 'SD',
        },
        {
          name: 'Suriname',
          code: 'SR',
        },
        {
          name: 'Svalbard and Jan Mayen',
          code: 'SJ',
        },
        {
          name: 'Swaziland',
          code: 'SZ',
        },
        {
          name: 'Sweden',
          code: 'SE',
        },
        {
          name: 'Switzerland',
          code: 'CH',
        },
        {
          name: 'Syrian Arab Republic',
          code: 'SY',
        },
        {
          name: 'Taiwan, Province of China',
          code: 'TW',
        },
        {
          name: 'Tajikistan',
          code: 'TJ',
        },
        {
          name: 'Tanzania, United Republic of',
          code: 'TZ',
        },
        {
          name: 'Thailand',
          code: 'TH',
        },
        {
          name: 'Timor-Leste',
          code: 'TL',
        },
        {
          name: 'Togo',
          code: 'TG',
        },
        {
          name: 'Tokelau',
          code: 'TK',
        },
        {
          name: 'Tonga',
          code: 'TO',
        },
        {
          name: 'Trinidad and Tobago',
          code: 'TT',
        },
        {
          name: 'Tunisia',
          code: 'TN',
        },
        {
          name: 'Turkey',
          code: 'TR',
        },
        {
          name: 'Turkmenistan',
          code: 'TM',
        },
        {
          name: 'Turks and Caicos Islands',
          code: 'TC',
        },
        {
          name: 'Tuvalu',
          code: 'TV',
        },
        {
          name: 'Uganda',
          code: 'UG',
        },
        {
          name: 'Ukraine',
          code: 'UA',
        },
        {
          name: 'United Arab Emirates',
          code: 'AE',
        },
        {
          name: 'United Kingdom',
          code: 'GB',
        },
        {
          name: 'United States',
          code: 'US',
        },
        {
          name: 'United States Minor Outlying Islands',
          code: 'UM',
        },
        {
          name: 'Uruguay',
          code: 'UY',
        },
        {
          name: 'Uzbekistan',
          code: 'UZ',
        },
        {
          name: 'Vanuatu',
          code: 'VU',
        },
        {
          name: 'Venezuela',
          code: 'VE',
        },
        {
          name: 'Viet Nam',
          code: 'VN',
        },
        {
          name: 'Virgin Islands, British',
          code: 'VG',
        },
        {
          name: 'Virgin Islands, U.S.',
          code: 'VI',
        },
        {
          name: 'Wallis and Futuna',
          code: 'WF',
        },
        {
          name: 'Western Sahara',
          code: 'EH',
        },
        {
          name: 'Yemen',
          code: 'YE',
        },
        {
          name: 'Zambia',
          code: 'ZM',
        },
        {
          name: 'Zimbabwe',
          code: 'ZW',
        },
      ]
    },
    $careerStages: function () {
      return [
        {
          label: this.$i18n.translate('Student'),
          value: 'Student',
        },
        {
          label: this.$i18n.translate('Volunteer'),
          value: 'Volunteer',
        },
        {
          label: this.$i18n.translate('Job Starter'),
          value: 'Job Starter',
        },
        {
          label: this.$i18n.translate('Professional Experienced'),
          value: 'Professional Experienced',
        },
      ]
    },
    $departments: function () {
      return [
        {
          label: this.$i18n.translate('Sales'),
          value: 'Sales',
        },
        {
          label: this.$i18n.translate('Production'),
          value: 'Production',
        },
        {
          label: this.$i18n.translate('Purchasing'),
          value: 'Purchasing',
        },
        {
          label: this.$i18n.translate('Research and Development'),
          value: 'Research and Development',
        },
        {
          label: this.$i18n.translate('Marketing'),
          value: 'Marketing',
        },
        {
          label: this.$i18n.translate('HR'),
          value: 'HR',
        },
        {
          label: this.$i18n.translate('IT'),
          value: 'IT',
        },
        {
          label: this.$i18n.translate('Account'),
          value: 'Account',
        },
        {
          label: this.$i18n.translate('Logistics'),
          value: 'Logistics',
        },
        {
          label: this.$i18n.translate('Logistics'),
          value: 'Operations',
        },
      ]
    },
    $careerStagesExtended: function () {
      return [
        {
          label: this.$i18n.translate('Internship'),
          value: 'Internship',
        },
        {
          label: this.$i18n.translate('Job Starter'),
          value: 'Job Starter',
        },
        {
          label: this.$i18n.translate('Experienced Professional'),
          value: 'Experienced Professional',
        },
        {
          label: this.$i18n.translate('Associate'),
          value: 'Associate',
        },
        {
          label: this.$i18n.translate('Management'),
          value: 'Management',
        },
        {
          label: this.$i18n.translate('Director'),
          value: 'Director',
        },
        {
          label: this.$i18n.translate('CEO'),
          value: 'CEO',
        },
      ]
    },
    $graduationTypes: function () {
      return [
        {
          label: this.$i18n.translate('Certificate of Secondary Education'),
          value: 'Certificate of Secondary Education',
        },
        {
          label: this.$i18n.translate('O Level'),
          value: 'O Level',
        },
        {
          label: this.$i18n.translate('AS Level'),
          value: 'AS Level',
        },
        {
          label: this.$i18n.translate('A Level'),
          value: 'A Level',
        },
        {
          label: this.$i18n.translate('Finished Apprenticeship'),
          value: 'Finished Apprenticeship',
        },
        {
          label: this.$i18n.translate('Bachelor of Arts'),
          value: 'Bachelor of Arts',
        },
        {
          label: this.$i18n.translate('Bachelor of Business Administration'),
          value: 'Bachelor of Business Administration',
        },
        {
          label: this.$i18n.translate('Bachelor of Fine Arts'),
          value: 'Bachelor of Fine Arts',
        },
        {
          label: this.$i18n.translate('Bachelor of Music'),
          value: 'Bachelor of Music',
        },
        {
          label: this.$i18n.translate('Bachelor of Musical Arts'),
          value: 'Bachelor of Musical Arts',
        },
        {
          label: this.$i18n.translate('Bachelor of Engineering'),
          value: 'Bachelor of Engineering',
        },
        {
          label: this.$i18n.translate('Bachelor of Science'),
          value: 'Bachelor of Science',
        },
        {
          label: this.$i18n.translate('Bachelor of Education'),
          value: 'Bachelor of Education',
        },
        {
          label: this.$i18n.translate('Bachelor of Laws'),
          value: 'Bachelor of Laws',
        },
        {
          label: this.$i18n.translate('Master of Arts'),
          value: 'Master of Arts',
        },
        {
          label: this.$i18n.translate('Master of Business Administration'),
          value: 'Master of Business Administration',
        },
        {
          label: this.$i18n.translate('Master of Education'),
          value: 'Master of Education',
        },
        {
          label: this.$i18n.translate('Master of Engineering'),
          value: 'Master of Engineering',
        },
        {
          label: this.$i18n.translate('Master of Fine Arts'),
          value: 'Master of Fine Arts',
        },
        {
          label: this.$i18n.translate('Master of Laws'),
          value: 'Master of Laws',
        },
        {
          label: this.$i18n.translate('Master of Music'),
          value: 'Master of Music',
        },
        {
          label: this.$i18n.translate('Master of Science'),
          value: 'Master of Science',
        },
        {
          label: this.$i18n.translate('Others'),
          value: 'Others',
        },
        {
          label: 'Dipl. Bauleiter',
          value: 'Dipl. Bauleiter',
        },
        {
          label: 'Dipl. Bauführer',
          value: 'Dipl. Bauführer',
        },
        {
          label: 'Dipl. Techniker HF',
          value: 'Dipl. Techniker HF',
        },
        {
          label: 'Dipl. Bauingenieur',
          value: 'Dipl. Bauingenieur',
        },
        {
          label: 'Bauökonmie',
          value: 'Bauökonmie',
        },
        {
          label: 'Architekt HF/ETH ',
          value: 'Architekt HF/ETH ',
        },
      ]
    },
    // TODO: check and remove this below property which should't be here
    // jobcode: function () {
    //   return [{
    //     companyId: null,
    //     runTime: null
    //   }]
    // },
    $languageList: function () {
      return [
        'Arabic',
        'Chinese',
        'Czech',
        'Danish',
        'Dutch',
        'English',
        'Finnish',
        'French',
        'German',
        'Greek',
        'Hebrew',
        'Hungarian',
        'Italian',
        'Japanese',
        'Korean',
        'Norwegian',
        'Polish',
        'Portuguese',
        'Romanian',
        'Russian',
        'Spanish',
        'Swedish',
        'Turkish',
      ]
    },
    $precireDynamicDescriptions: function () {
      return {
        Optimistic: [
          `The participant does not seem optimistic. In her or his expression, she or he usually remains realistic to pessimistic. This means that statements rarely lead to disappointment, but can also mean that opportunities are not taken in the first place.`,
          `The participant rarely appears optimistic. She/he tends to remain realistic to pessimistic in her/his expression. Although this means that statements rarely lead to disappointment, it can also mean that possible opportunities are not taken because of a negative expectation.`,
          `The participant expresses some optimism, draws positive conclusions from experiences and conveys that anything is possible. On the other hand, the participant remains realistic to pessimistic in her/his evaluation of the situation. The average level leads to opportunities being partially seized, but only if the risk seems assessable. `,
          `The participant often communicates optimistically and thus conveys both positive conclusions from experiences and a confident perspective for the future. In this way, she/he manages to convey the attitude that everything is theoretically achievable and possible in many situations, thus motivating others to seize opportunities.`,
          `The participant communicates very optimistically and thus always draws positive conclusions from experiences and transfers a confident perspective on the future. In doing so, she/he conveys the attitude that everything is theoretically achievable and possible and motivates others to seize opportunities and take risks in return. A too strong tendency in this direction can lead to more frequent disappointments of very positive expectations. `,
        ],
        Visionary: [
          `The participant speaks with little visionary elements. She/he seldom tends to move to a higher level and imagine glorious or promising future scenarios. Instead, she/he sticks to actual events and plans the next steps in a very down-to-earth way. While this makes implementation easier and seems very realistic, it does not convey promising visions that others can believe in.`,
          `The participant rarely communicates in a visionary way and has little tendency to imagine glorious and promising future scenarios. Instead, she/he more often stays with what is real and focuses on the next steps in a down-to-earth manner. This makes implementation easier and seems realistic, but it seldom conveys promising vision that others can believe in.`,
          `The participant sometimes transports visionary elements. Occasionally she/he tends to talk about how she/he can achieve even more and imagines promising future scenarios. At the same time, she/he often remains down-to-earth about the actual situation and combines these two elements. With an average score, it is usually still difficult to convey a vision that others can believe in and that promises a glorious future. `,
          `The participant communicates visionary. She/he tends to think beyond the achievements and talks about further goals to be achieved. She/he imagines promising future scenarios for herself/himself and others. She/he usually still keeps the down-to-earth connection to relate to more conservative thinking people, but often manages to convey a vision that promises a glorious future.`,
          `The participant seems very visionary. She/he tends to go through promising future scenarios and usually manages to communicate visions that promise a glorious future in addition to the goals to be achieved and potential improvements of the current situation. A very high value also means, that very down-to-earth people often cannot relate to this kind of communication and have to be convinced by factual arguments. `,
        ],
        Positive: [
          `The participant has a negative communicative effect. She/he does not see the world in a rosy light, but with many critical aspects about which she/he thinks a lot. Therefore she/he is not surprised by challenges, but has already seen them coming and is prepared for negative outcomes. The ""Self-fulfilling Prophecy"" can lead to the pessimistic considerations being more likely to occur. Due to the lack of a positive basic attitude, the participant can inhibit herself/himself, since few positive and problem-free outcomes are addressed. This negative mood may transfer to others. `,
          `The participant rarely has a positive communicative effect. She/he sees the world with many critical aspects that she/he thinks about. Therefore, she/he is not surprised by challenges, but has usually already anticipated them in advance and is thus prepared for negative outcomes. The ""Self-fulfilling Prophecy"" can lead to the fact that her/his pessimistic considerations are more likely to occur. Due to the lack of a positive basic attitude, it can happen that the participant inhibits herself/himself.`,
          `The participant has a partially positive communicative effect. She/he usually has a very realistic view on challenges, so she/he is also prepared for negative outcomes. The positive and negative views are balanced in her/his communication. Due to this, it is mostly difficult for her/him to infect others with a positive attitude and she/he is easily influenced by negative statements from other people. `,
          `The participant has a positive communicative effect. She/he sees a positive way out of critical situations and does not lose her/his confident attitude. Based on the ""Self-fulfilling Prophecy"" this leads to the fact that the positive outcomes are more likely to occur because the participant activates and steers her-/himself and others towards them. `,
          `The participant has an extremely positive communicative effect. She/he has a positive attitude in nearly every situation and does not lose her/his confident attitude. On the basis of ""Self-fulfilling Prophecy"", this leads to the fact that the positive outcomes are more likely to occur, as the participant activates and steers herself/himself and others towards them. Due to this high level, the participant can be unprepared for negative events. `,
        ],
        Supportive: [
          `The participant hardly transports support through his or her language. It rarely happens that she/he simply listens to her/his conversational partners, tries to understand their situation and signals support without taking a personal stand on what is being said. Although a low level is often perceived as particularly independent, it can lead to the fact that conversational partners perceive less helpfulness and understanding. `,
          `The participant rarely transports support through her/his language. She/he sometimes finds it difficult to just listen without making an evaluation. She/he shows only partial understanding for the challenges of others, or seldom encourages them in their actions. A rather low level is often perceived as particularly independent, but can lead to the fact that conversational partners perceive less willingness to help.`,
          ` The participant transports an average amount of supportive communication. In some situations she/he holds back during a conversation and encourages her/his conversational partner. She/he then actively supports and tries to understand the situation of her/his counterpart. In other situations it is more difficult for her/him to just listen. The participant then tends to express her or his personal opinion immediately and thus expresses little understanding or helpfulness.`,
          `The participant transports a lot of support through her/his language. Often she/he takes up the views of her/his conversational partner in a conversation without evaluating them and shows understanding and helpfulness. The participant encourages others and thus helps them to bring their concerns to the forefront. In this way, the participant empowers her/his environment. `,
          `The participant transports a lot of support through her/his language. Often she/he takes up the views of her/his conversational partner without evaluating them and shows understanding and willingness to help. The participant often encourages others and helps them to talk about their concerns. In this way she/he empowers her/his environment. A very high level can lead to the fact that one's own interests are put too much into the background.`,
        ],
        Empathic: [
          `The participant does not seem very empathic. She/he does seldom respond to other people's feelings or try to understand their situation. She/he acts extremely rational and represents her/his own standpoints without being influenced by the feelings of others. To others this may seem distant, or even cold and egoistic. `,
          `The participant rarely appears empathic. She/he does not seem to pay much attention to other people's feelings or seldom tries to understand their situation. Thus she/he acts extremely rational and usually represents her/his own points of view without being influenced by the feelings of others. To others this may seem very distant.`,
          `The participant appears empathic in some situations, she/he then carefully considers the feelings of her/his counterpart and understands them. Sometimes, however, she/he also reacts extremely rational and pays little attention to the feelings of others. Depending on the context, she/he thus decides between the two options for action. By switching between closeness and distance to the conversational partners, she/he may appear inconsistent to others. `,
          `The participant appears empathic. She/he responds very carefully to the feelings of her/his counterpart, questions them and puts her-/himself in the other person's position. It can happen that she/he loses the distance to events and is emotionally strongly taken by others.`,
          `The participant seems very empathic. She/he is extremely attentive to the feelings of her/his counterpart, questions them and puts herself/himself directly in the other person's position. As a result, she/he may quickly lose the distance from what is happening, acts and argues strongly driven by emotions. `,
        ],
        Friendly: [
          `The participant hardly expresses friendliness. She/he usually keeps her/his distance to other people and his/her opinions are thus rarely influenced on an emotional level. She/he rigidly holds her/his opinion and very rarely compromises. This makes it more difficult to establish a relationship with her/him, since the first reactions are quickly perceived as unfriendly. `,
          `The participant expresses little friendliness. Mostly she/he keeps her/his distance and is rarely influenced on an emotional level. This makes it difficult for others to establish a relationship with her/him. Tha participant may sometimes appear unfriendly.`,
          `The participant partly expresses friendliness. Depending on the situation, she/he quickly succeeds in establishing closeness to other people and is conveying sympathy. In other cases, she/he keeps the distance, so she/he can decide in which situations the closeness is appropriate and in which the distance should rather be kept.`,
          `The participant expresses friendliness through her/his language, thus she/he usually quickly builds up closeness to others and conveys sympathy.`,
          `The participant expresses a high degree of friendliness through her/his language, which enables her/him to build up a close relationship with others very quickly and conveys a great deal of sympathy. In negotiations and disputes this may sometimes lead to her/him giving in quickly and thus not representing her/his interests. `,
        ],
        Motivating: [
          `The participant hardly communicates in a captivating way. She/he sticks to the content rather than creating a strongly motivating atmosphere. In this way she/he seldom succeeds in conveying her/his own enthusiasm for a topic to her/his listeners. `,
          `The participant only rarely has a captivating or inspiring effect. Even if there ar situations in which she/he uses a stimulating language that motivates and can generate enthusiasm, there are a lot of situations in which she/he finds it difficult to activate her/his conversational partners. This means that the participant seldom succeeds in conveying her/his own enthusiasm for a topic to listeners.`,
          `Situatively, the participant communicates in an activating, stimulating way. In these situations, she/he is able to inspire and motivate conversational partners. Her/his communication keeps a balance between demanding activity and bringing objectivity into a situation. However, when it comes to transferring one's own enthusiasm to others, the participant only partially succeeds.`,
          `The participant has a talent for motivating communication and enjoys using it. In this way, she/he often succeeds better than others in stimulating and maintaining an inspiring atmosphere in conversations, so that she/he transfers her/his own enthusiasm to the conversational partners. `,
          `The participant communicates in a very motivating way, conveying enthusiasm and activity. She/he usually succeeds in transferring her/his own enthusiasm. This makes it easier to get listeners excited and enthusiastic and thus promotes agility in others. On the other hand, too high a demand for motivation and activity can have an overwhelming effect on conversational partners. `,
        ],
        Confident: [
          `The participant seldom communicates self-confidence in social situations. She/he is often reserved or reticent and rarely talks on a personal level. Although this leads to her/him being perceived as seriously, it also means that she/he makes less use of individual relationships with others. `,
          `The participant only sometimes communicates self-confidence in social situations. She/he remains rather reserved and therefore seems to be less approachable. She/he usually lets others step into the spotlight and tends to hold back. Although this leads to her/him appearing serious, it also has the consequence that she/he is perceived as less present. `,
          `The participant conveyes an average level of self-confidence in social situations. Therefore, she/he keeps a balance between a reserved effect, in which she/he seems to be less approachable and situations in which she/he is perceived as outgoing. More self-confident communication could lead to an even stronger perception of presence, and networks being established and expanded more quickly. `,
          `The participant conveyes a high level of self-confidence in social situations, rarely holds back and does not allow herself/himself to be discouraged. With the help of self-confident communication, she/he quickly succeeds in reaching a personal level with others, creating presence and conveying social self-confidence. `,
          ` The participant communicates very self-confident. She/he tends to put herself/himself in the centre of attention and is thus perceived as a self-confident communicator. She/he easily succeeds in establishing connections to others and forming networks. At the same time, a very high result may lead to others feeling pushed into the background.`,
        ],
        Composed: [
          `The participant does not tend to communicate relaxed. Instead, excitement and nervousness are in the foreground. This can lead hasty or thoughtless statements. The way she/he expresses herself/himself also affects her/his own mood, so that a self-reinforcing process can occur. At the same time, visible changes in emotionality are often perceived as authentic. `,
          `The participant sometimes appears composed and relaxed, but often excitement and nervousness are in the foreground. In such situations, this can lead to things being said hastily or it can be difficult for the participant to find the right words. The way she/he expresses her-/himself also affects her/his own mood, so that a self-reinforcing process can occur. However, a visible change in emotionality also has an authentic effect. `,
          `The participant has an average result in composed and relaxed communication. She/he therefore sometimes conveys a calm approach, which can radiate to her/his conversational partners. Situatively, she/he succeeds in calming stressful discussions. In other situations she/he contributes to the heating of the situation and seems nervous, tense or even anxious.`,
          `The composed communication style of the participant is above average. It is easy for her/him to appear balanced and relaxed and to transmit calmness with this approach. Situatively, she/he still finds it difficult to bring stressful situations back to a calm level. `,
          `The participant often appears relaxed and rarely nervous, excited or even anxious. This enables her/him to choose words carefully and to express her-/himself optimally, even in difficult situations. `,
        ],
        Formal: [
          `The participant is characterised by an extremely low formal effect. She/he does not make statements based on measurable and provable facts, but on personal sensations, feelings and emotions. This means that her/his statements do seldom seem to be objective. `,
          `The participant is characterised by a low formal effect. She/he usually does seldom make statements based on measurable and provable facts, but increasingly on personal sensations, feelings and emotions. This means that her/his statements are mostly perceived as rather emotional than rational.`,
          `The participant appears formal or emotional, depending on the situation. In some situations it seems easier for her/him to argue with numbers, data and facts, but in other situations she/he transfers a subjective view. A mixture of rationality and emotions are the result. `,
          `The participant communicates formally. She/he describes facts and situations objectively, using provable figures, data and facts. Thus, discussions take place on a factual level. The low level of emotionality can seem distant to others. `,
          `The participant communicates very formally. She/he describes facts objectively, with the help of provable numbers, data and facts. As a result, discussions take place on an extremely rational and objective level. The low level of emotionality can make the person seem very distant.`,
        ],
        Structured: [
          `The participant appears hardly structured and mostly communicates unsorted and spontaneous. She/he rarely puts statements into an understandable order, e.g. according to the temporal events. Instead, she/he gives information freely as it comes into her/his head. This makes it very difficult for conversational partners to follow and understand the topics. `,
          `The participant rarely appears structured, and communicates rather unsorted and spontaneous. She/he rarely puts statements into an understandable order, e.g. according to the temporal events. Instead, she/he releases information as it comes into her/his head. This makes it difficult for conversational partners to follow and understand the topics. `,
          `The participant is sometimes spontaneous and in other situations structured. It is usually easy for her/him to present the information in an understandable structure. But she/he also has the flexibility to break away from a planned structure in order to react spontaneously. `,
          `The participant is structured. She/he therefore communicates in logical structures and usually follows a common thread in conversations. Thus, it is usually easy for conversational partners to follow the explanations and understand the information. `,
          `The participant is very structured. She/he therefore communicates in logical structures and always follows a common thread in conversations. It is hence very easy for conversational partners to follow her/his explanations and understand the information, as everything is explained with a clear reference to each other. The strong structure makes it difficult for the participant to deal with spontaneous changes.`,
        ],
        'Goal-oriented': [
          `The participant rarely appears goal-oriented. Even though the use of reasoning is often helpful to create understanding and to open up a holistic perspective, it is more difficult to return a conversation to the desired direction again and to initiate actions. The participant does not tend to communicate concise. This makes it harder to find pragmatic solutions and to pursue a long-term goal.`,
          `The participant sometimes appears goal-oriented, but often also pondering. Although the use of reasoning can be helpful in creating understanding and opening up a holistic perspective, it makes it more difficult to always return a conversation to the desired direction and to immediately initiate action. The participant does not tend to communicate concise. This makes it harder to find pragmatic solutions and to pursue a long-term goal.`,
          `The participant shows an average level of goal-orientation. This means that her/his statements are sometimes very action-oriented and demand immediate activities. On the other hand, she/he sometimes weighs up statements. This creates a balance between reflection and action. However, in an uncertain environment, quick and pragmatic actions are often useful. `,
          `The participant often appears goal-oriented. This means that her/his statements are mostly action-oriented and call for immediate activities. In doing so, she/he sets a clear tendency in conversations towards action rather than reflection and often leads conversations back to the intended goal. `,
          `The participant communicates in a very goal-oriented way. She/he is mostly trying to find a practical solution and leading conversations back to the desired direction.`,
        ],
        Goal_oriented: [
          `The participant rarely appears goal-oriented. Even though the use of reasoning is often helpful to create understanding and to open up a holistic perspective, it is more difficult to return a conversation to the desired direction again and to initiate actions. The participant does not tend to communicate concise. This makes it harder to find pragmatic solutions and to pursue a long-term goal.`,
          `The participant sometimes appears goal-oriented, but often also pondering. Although the use of reasoning can be helpful in creating understanding and opening up a holistic perspective, it makes it more difficult to always return a conversation to the desired direction and to immediately initiate action. The participant does not tend to communicate concise. This makes it harder to find pragmatic solutions and to pursue a long-term goal.`,
          `The participant shows an average level of goal-orientation. This means that her/his statements are sometimes very action-oriented and demand immediate activities. On the other hand, she/he sometimes weighs up statements. This creates a balance between reflection and action. However, in an uncertain environment, quick and pragmatic actions are often useful. `,
          `The participant often appears goal-oriented. This means that her/his statements are mostly action-oriented and call for immediate activities. In doing so, she/he sets a clear tendency in conversations towards action rather than reflection and often leads conversations back to the intended goal. `,
          `The participant communicates in a very goal-oriented way. She/he is mostly trying to find a practical solution and leading conversations back to the desired direction.`,
        ],
        Reliable: [
          `The participant rarely communicates clear reliability. As a result, responsibilities assumed by her/him are not conveyed to others.This leads to the fact that conversational partners may sometimes not be sure how stable the statements are. On the other hand, this makes the participant appear more flexible and keeps several paths open. `,
          `The participant only sometimes communicates clear reliability. As a result, responsibilities assumed by her/him are just sometimes conveyed to others. This leads to the fact that conversational partners may sometimes not be sure how stable the statements are. On the other hand, this makes the participant appear more flexible and keeps several paths open. `,
          ` The participant sometimes conveys clear reliability and sometimes leaves open who is responsible. In this way she/he keeps a balance between the very reliable effect and the flexibility to communicatively keep several options open. Even though in most situations the dialogue partner is sure that the statements are binding, changes or ambiguities in the expression can lead to uncertainty. A higher level of responsibility leads to more specific agreements. `,
          `The participant often communicates reliably and makes it clear that statements made one day are still valid the next day. For example, she/he specifies clear responsibilities and also communicates what she/he is accountable for. `,
          `The participant is reliable and makes it clear that statements made one day are still valid the next day. For example, she/he specifies responsibilities and communicates what she/he is accountable for. At the same time, this very responsible communication can lead to the participant quickly committing to one of several path. `,
        ],
        Intellectual: [
          `The participant hardly conveys intellectuality. She/he phrases simply, without the use of many technical and foreign words. This makes it easier for others to follow the explanations. However, it is very difficult for the participant to express complex content in a precise and detailed way.`,
          `The participant just sometimes conveys intellectuality. She/he mostly phrases simply, without the use of many technical and foreign words. This makes it easier for others to follow the explanations. However, it is often difficult for the participant to express complex content in a precise and detailed way. `,
          `The participant has an average result. Depending on the situation, communication may seem intellectual or simple. On the one hand, content can be communicated in a very precise, detailed and well thought-out manner. On the other hand, he/she sometimes succeeds in only expressing the main message in simple words, making it easier for dialogue partners to follow. `,
          `The participant has an average result. Depending on the situation, communication may seem intellectual or simple. On the one hand, content can be communicated in a very precise, detailed and well thought-out manner. On the other hand, he/she sometimes succeeds in only expressing the main message in simple words, making it easier for dialogue partners to follow. `,
          `The participant seems very intellectual. She/he communicates very well thought out and with many technical terms and foreign words. Contents are conveyed precisely and in detail. This makes it easier to talk about specific technical issues. At the same time, this form of communication can be overwhelming for others.`,
        ],
        Cooperative: [
          `The participant's communication is not cooperative. He/she finds it very difficult to put him/herself in the position of the dialogue partner, to empathise with his/her feelings and to relate to them. This can make it difficult for others to establish a relationship with the participant, as he/she seems to be hardly oriented towards their needs or those of the team. `,
          `The participant's communication is not very cooperative. She/he usually finds it difficult to put herself/himself in the position of her/his dialogue partner and to convey empathy. This can make others feel that it is difficult to establish a relationship with the participant, as he/she only sometimes seems to be oriented towards their needs or those of the team.`,
          `The communication of the participant is on average cooperative. In some situations it is easy for her/him to put herself/himself in the other person's position and support him/her, in other situations this is not achieved. As a result, the participant does not give up his or her goals for others, but sometimes seems to decide in the interest of the team. `,
          `The participant communicates cooperatively. It is usually easy for him/her to perceive the feelings of others and to respond to them sensitively and carefully. She/he likes to support other people and usually meets them in a friendly manner. `,
          `The participant communicates very cooperatively. It is easy for her/him to perceive the feelings of others and to respond to them sensitively and thoughtfully. The participant likes to support other people and usually meets them in a friendly manner. Situatively, the participant puts too much emphasis on the concerns of others. `,
        ],
        Venturing: [
          `The participant does not communicate venturing. She/he tends to express herself/himself very realistically and tends to assume negative outcomes. Security seems to be important to her/him and she/he has a tendency to constantly ask questions about feasibility instead of forging great visions. `,
          `The participant seldom communicates venturing. She/he often tends to express herself/himself realistically and to assume negative outcomes. Security seems to be important to her/him and she/he has a tendency to ask questions about feasibility rather than forge great visions. `,
          `The communication of the participant is partly venturing. While in some situations the participant focuses on the positive aspects of the past and looks confidently to the future, in other situations the participant finds it difficult to develop a vision of a promising future because he or she clings strongly to what might not work. `,
          `She/he conveys a positive mood and has an optimistic view of the future. With this attitude, the participant is not afraid to take risks and it is easier for him/her to provide a convincing vision. `,
          `She/he usually conveys a positive mood and has an optimistic view of the future. With this attitude, the participant is more likely to take risks and encourages people in his/her environment to believe in and work towards positive visions of the future. If the level is too high, the realistic attitude may suffer. `,
        ],
        Professional: [
          `The participant's professional communication is low. It is hard for her/him to convey conscientiousness. This makes it more difficult for listeners to follow the statements and little commitment can be perceived.`,
          `The participant does not communicate in a very professional way. Usually it is hard for her/him to convey conscientiousness. As a result, it is sometimes difficult to follow her/his statements and little commitment can be perceived. `,
          `The participant's communication is averagely professional. In some situations she/he communicates rationally, the statements have a clear structure and appear intellectual as well as committed and goal-oriented. In these situations, a conscientious style of expression emerges, which makes it easier for dialogue partners to perceive, pursue and achieve a clear goal. `,
          `The participant often communicates professional. This usually creates a conscientious effect that conveys high performance standards and makes it easier for dialogue partners to perceive a clear goal.`,
          `The participant communicates very professional. This creates a very conscientious effect, which conveys high performance standards and makes it easier for dialogue partners to perceive a clear goal. In very extreme cases, the participant seems distant and unapproachable. `,
        ],
        Innovative: [
          `The participant does not communicate in an innovative way. Her/his communication is based on pragmatic derivations and traditional structures. For the most part, it is sufficient for her/him to have a rough understanding of the theoretical background. This is efficient, but rarely leads to a new perspective being opened up. `,
          `The participant communicates only partially innovative. Her/his communication tends to be based on pragmatic derivations and traditional structures. It is usually enough for him/her to have a rough understanding of the theoretical background.  This is efficient, but rarely leads to a new perspective being opened up. `,
          `The participant's communication is on average innovative.She/he partly attaches importance to pragmatism and partly wants to understand the theoretical background.  The participant only sometimes gets lost in detail, but also rarely opens up completely new perspectives. `,
          `The participant communicates in an innovative way. She/he enjoys having in-depth discussions and gaining a comprehensive theoretical understanding of topics. The participant often brings in new and unusual ideas and thus opens up completely new perspectives. `,
          `The participant seems very innovative. He/she often and willingly conducts in-depth discussions and gains a comprehensive theoretical understanding of topics. The participant often brings in new and unusual ideas. In its extreme form, this can appear too well thought out. `,
        ],
        Competitive: [
          `The communication of the participant is not very competitive. This means she/he rarely enters into competition with others by reacting impulsively or aggressively. The participant hardly puts pressure on others, as he/she prefers harmonic solutions. Her/his reactions are deliberate and very rarely caused by a sudden impulse. This can lead to a low level of immediacy and authenticity and to confrontations being avoided.`,
          `The communicative effect of the participant is rarely competitive. She/he hardly ever competes with others by reacting impulsively or aggressively. The participant prefers harmonic solutions. Her/his reactions are deliberate and only sometimes caused by a sudden impulse. This can lead to a low level of perceived immediacy and authenticity and to confrontations being avoided.`,
          `The participant expresses an average level of competitiveness. Depending on the situation she/he reacts in a quick-tempered and restless way and thus enters into competition with others. If the situation requires it, he/she can put pressure on others, but does so in a conscious and controlled way.`,
          `The participant communicates rather competitively. In many situations she/he reacts impulsively. Her/his impatience often leads to heated discussions, which are sometimes necessary in order to make progress. This puts her/him more often in competitive situations with others.`,
          `The participant often communicates competitively. In many situations she/he reacts impulsively or irritably. His or her impatience often leads to heated discussions in which the participant sometimes even provokes dialogue partners. As a result, she/he is more often in competing with others. A too high result indicates a very high willingness to conflict.`,
        ],
        Directing: [
          `The participant rarely communicates in a directing and extraverted way. Instead, she/he usually stays in the background and avoids the big stage. Others perceive the participant as shy and reserved. It is more difficult for her/him to exercise authority and take the reins into her/his hands. In critical conversation situations she/he seems rather nervous. `,
          `The participant only sometimes communicates in a directing and extraverted way. Instead, she/he partly stays in the background and avoids the big stage. Others perceive her/him as shy and reserved. It is more difficult for the participant to exercise authority and take the reins into her/his hands. In critical situations she/he seems rather nervous.`,
          `The participant has an average directing effect. In some situations she/he appears socially self-confident and takes the lead in conversations. In others, she/he may seem reserved and insecure, letting others go first.`,
          ` The participant communicates in a rather directing way. She/he tends to be socially self-confident and sets the tone in communications. Even when things get critical, the participant is often calm and confident. `,
          `The communication of the participant is very directing. Even when things get critical, the participant is often calm and confident. She/he likes to set the tone and has a great social self-confidence. To others she/he thereby appears dominant. `,
        ],
        Inspiring: [
          `The communication of the participant is not very inspiring. She/he rarely makes statements that inspire others and remain in their memory for a long time. This makes it harder for her/him to motivate others, to be impressive and to ignite the fire of listeners for a certain goal. `,
          `The communication of the participant is only sometimes inspiring. She/he partially makes statements that inspire others and remain in their memory for a long time. This makes it harder for her/him to motivate and impress others and to ignite the fire of listeners for a specific goal. `,
          `The participant communicates in an average inspiring way. In some situations she/he finds it easy to inspire others and captivate them in a story. Sometimes, however, she/he does not succeed in inspiring and motivating for a goal. `,
          `The participant communicates inspiringly. She/he usually succeeds in motivating others and in remaining in memory with her/his stories. In these situations she/he is enthusiastic about her/his topics and appears charismatic. `,
          `The communication of the participant is very inspiring. She/he succeeds in motivating others and in remaining in the memory with her/his stories. This way the participant inspires the audience with the topics she/he is talking about and appears charismatic. 
        `,
        ],
        Aggressive: [
          `The participant almost never communicates aggressively and does not exert pressure on others by issuing orders. They usually communicate peacefully and willingly to compromise and only rarely vent their anger. They do not want to provoke or incite their counterpart. As a result, they encourage compromises.`,
          `The participant hardly communicates aggressively and rarely exerts pressure on others by issuing orders. They usually communicate peacefully and willingly to compromise and only occasionally vent their anger. They rarely want to provoke or incite their counterpart. As a result, they often encourage compromises.`,
          `The participant sometimes communicates aggressively. In these situations, they give orders and exert pressure on others. When they vent their anger, interlocutors may feel provoked by them. In other situations, however, they communicate in a compromising manner.`,
          `The participant communicates aggressively more often. In these situations, they give orders and exert pressure on others. When they vent their anger, interlocutors may feel provoked by them. Only occasionally do they communicate in a compromising manner.`,
          `The participant usually communicates aggressively, using appellative language and freely venting their anger. They often use inciting words that can stimulate but also create a sense of pressure on interlocutors.`,
        ],

        Authoritative: [
          `The participant's communication is not authoritarian. They give their communication partners a lot of freedom and do not actively control what happens. That makes it easy for their communication partners to contribute their own ideas and to exchange opinions creatively. At the same time, the participant finds it difficult to give direction to conversations, to create a framework, and thus to exercise authority. `,
          `The participant's communication is not very authoritarian. They allow their communication partners freedom and rarely actively direct what happens. As a result, communication partners find it easier to contribute their own ideas and to exchange opinions creatively. At the same time, the participant finds it more difficult to guide the conversation, to create a framework, and thus to exercise authority.`,
          `The participant's communication is sometimes authoritarian. Situationally, they steer conversations and provide guidance. Sometimes, however, they tend to let conversations run their course and allow others to frame the conversations.`,
          `The participant's communication is more often authoritarian. Situationally, they steer conversations and give guidance. Rarely do they let conversations run their course and allow others to frame the conversations.`,
          `The participant communicates in a very authoritarian manner. Therefore, they take the lead in communication and determine both the direction of the conversation and the talking shares of the conversation partners. As a result, the participant provides the framework for the conversation and focuses on the achievement of goals. They can make others feel restricted by their dominant appearance. They may then not express ideas as freely.`,
        ],

        Dramatic: [
          `The participant's communication is not very dramatizing. They communicate rationally, factually and realistically. They report what has actually happened and do not embellish it to make the story more exciting or thrilling. As a result, many of their narratives seem believable, but also unexciting.`,
          `The participant's communication is somewhat dramatized. They mostly communicate in a rational, factual, and realistic manner. In doing so, they report what has actually happened and only occasionally embellish it to make the story more exciting or thrilling. As a result, many of their narratives seem believable and moderately entertaining.`,
          `The participant is able to communicate in both a dramatizing and realistic manner. Depending on the situation, they resort to the rational, factual style of communication, merely relaying information or events as they happened. In other situations, they embellish narratives and present events in a more exciting way than they actually were.`,
          `The participant often communicates in a dramatizing manner. They often embellish narratives and portray events more exciting than they actually were. As a result, they often convey urgency, explosiveness, or tension. However, the exaggerations occasionally make statements seem less realistic.`,
          `The participant communicates in a dramatizing manner. They embellish narratives and portray events as more exciting than they actually were. In this way, they usually convey urgency, explosiveness, or tension. On the other hand, too much exaggeration can make statements seem less realistic.`,
        ],

        Impressive: [
          `The participant's communication seems unimpressive to others. They find it difficult to draw others into the spell of their narrative. As a result, their communication quickly appears boring and it is difficult to remember the information conveyed. Due to the minimal expression, they do not always have to be in the center of the action, they can also leave the stage to others and place themselves in the background.`,
          `The participant's communication rarely makes an impressive effect on others. They usually find it difficult to draw others into the spell of their narrative. As a result, their communication often appears boring and the information conveyed is only occasionally remembered. Due to moderate expression, they are only occasionally the center of attention, but they often let others take the stage, thus relegating themselves to the background.`,
          `The participant's communication sometimes has an impressive effect on other people. They find it easy in some situations to draw others into the spell of their narrative and the information conveyed is well remembered. In other situations, however, they manage not to stand out and leave a lasting impression on others. Their narrative does not always perish and is likely to be remembered in some cases. Depending on the situation, they can be both impressive and understated. As a result, they demonstrate the ability to recognize in which situations they need to take charge and in which, on the other hand, they need to stand back, take a place in the background, so as not to steal another person's thunder, for example.`,
          `The participant's communication has an above-average impressive effect on other people. They find it very easy to draw others into the spell of their narrative and conveyed information is usually well remembered. They as a person are also remembered.`,
          `The participant's communication has an extremely impressive effect on others. They find it very easy to draw others into the spell of their narrative and information conveyed is well remembered. They as a person are also remembered for a long time.`,
        ],

        Independent: [
          `The participant rarely communicates independently. They ponder a lot about their statements and usually adapt them to common opinions in order to avoid clashing with other people. They therefore rarely express their attitudes. This form of communication prevents unnecessary conflict, though it also prevents necessary arguments for them to make their point.`,
          `The participant occasionally communicates independently. They ponder a lot about their statements and often adapt them to common opinions in order to avoid clashing with other people. They therefore rarely express their attitudes. This form of communication often prevents unnecessary conflict, but often prevents necessary arguments for them to make their point.`,
          `The participant's communication is independent of others in some situations and in other situations they make their statements dependent on the ideas and opinions of others. If they are uncertain and ponder their statements, they prefer to adapt them to common opinions. If, on the other hand, they feel confident, they take a stand on an issue and express their opinions free from seeking the approval of others.`,
          `The participant communicates a certain independence in their language and often makes their statements free of prevailing opinions. They frequently speak their convictions, even if it means arguing against the ideas of others. Discussions or disagreements are not seldom shied away from. This occasionally creates the potential for conflict, which can provoke discussion.`,
          `The participant communicates very much independently in their language and makes their statements free of prevailing opinions. They speak their convictions even if it means arguing against the ideas of others. Discussions or disagreements are not shied away from. This creates an increased potential for conflict that can provoke discussion.`,
        ],

        Philosophical: [
          `The participant does not communicate philosophically. They do not focus on the theoretical background of statements. Therefore, they question the topics superficially at most in order to get a rough overall picture of the process. This superficiality ensures that they come to actions more quickly, but often the depth of understanding is lost.`,
          `The participant rarely communicates philosophically. They only occasionally focus on the theoretical background of statements. They therefore often only question the topics superficially in order to get a rough overall picture of the process. This superficiality ensures that they come to actions more quickly, but often the deeper understanding is lost.`,
          `In some situations they question a lot, want to understand the theoretical background and communicate it to others. Then they lead deep discussions with high information density. On the other hand, in other situations, it is also enough for them to learn something about the practical aspects and not develop a deep understanding of the subject.`,
          `The participant often communicates philosophically. They question many things and also want to understand the theoretical background and communicate it to others. They therefore have very deep discussions with high information content. As a result, they can sometimes get lost in the depth of information, so that discussions sometimes do not come to an end and the actual goal can be lost from view.`,
          `The participant communicates very philosophically. They question everything and also want to understand the theoretical background down to the smallest detail and communicate this to others. They therefore have very in-depth discussions with a high information content. As a result, they can get lost in the depth of information, discussions do not come to an end and the actual goal is lost from sight.`,
        ],

        Unconventional: [
          `The participant almost never communicates in an unconventional way. They tend to stick to tried and tested ideas and almost never make unusual or crazy statements. Thus, they convey consistency rather than unconditional innovation.`,
          `The participant occasionally communicates in an unconventional manner. However, they usually stick to tried and tested ideas and rarely make unusual or crazy statements. Mostly they convey consistency rather than innovation.`,
          `The participant sometimes communicates traditionally and sometimes unconventionally, depending on the situation. They have imaginative ideas, share them situationally, and thus occasionally discuss the unusual. However, it will rarely happen that they make crazy statements in a conversation and thus open up yet another completely new perspective.`,
          `The participant often communicates in unconventional and imaginative ways. As a result, they sound inventive and manage to open up unusual perspectives to others. If the ideas become too unusual, others may get lost in the statements the participant makes.`,
          `The participant usually communicates in unconventional and imaginative ways. As a result, they sound inventive and manage to open up unusual and sometimes crazy perspectives to others. If the ideas get too unusual, others may get lost in the statements the participant makes.`,
        ],

        Impulsive: [
          `The participant communicates thoughtfully and deliberately. Considerations are given a great deal of attention and the language appears to be emotionally controlled. Impulsive, emotionally reactive or even choleric behavior is not expected in terms of communication.`,
          `The participant communicates in a rather thoughtful and deliberate manner. Considerations are given a great deal of attention and the language usually appears emotionally controlled. Impulsive, emotionally reactive or even choleric behavior is rarely to be expected in terms of communication.`,
          `The participant communicates impulsively on average, is usually emotionally controlled and very positive. Impulsive communication is more likely to occur in pleasure and has a rousing character.`,
          `The participant does not always communicate thoughtfully. Considerations are given little attention and the language often appears emotional. Behavior can be impulsive, excited, and emotionally reactive and even agitated.`,
          `Participant communicates with little thoughtfulness. Considerations are given hardly any attention and the language usually appears emotional. Behavior may be impulsive, excited, and emotionally-reactive and even agitated.`,
        ],

        'Self-confident': [
          `The participant seldom communicates self-confidence in social situations. She/he is often reserved or reticent and rarely talks on a personal level. Although this leads to her/him being perceived as seriously, it also means that she/he makes less use of individual relationships with others.`,
          `The participant only sometimes communicates self-confidence in social situations. She/he remains rather reserved and therefore seems to be less approachable. She/he usually lets others step into the spotlight and tends to hold back. Although this leads to her/him appearing serious, it also has the consequence that she/he is perceived as less present.`,
          `The participant conveyes an average level of self-confidence in social situations. Therefore, she/he keeps a balance between a reserved effect, in which she/he seems to be less approachable and situations in which she/he is perceived as outgoing. More self-confident communication could lead to an even stronger perception of presence, and networks being established and expanded more quickly.`,
          `The participant conveyes a high level of self-confidence in social situations, rarely holds back and does not allow herself/himself to be discouraged. With the help of self-confident communication, she/he quickly succeeds in reaching a personal level with others, creating presence and conveying social self-confidence.`,
          `The participant communicates very self-confident. She/he tends to put herself/himself in the centre of attention and is thus perceived as a self-confident communicator. She/he easily succeeds in establishing connections to others and forming networks. At the same time, a very high result may lead to others feeling pushed into the background.`,
        ],

        Self_confident: [
          `The participant seldom communicates self-confidence in social situations. She/he is often reserved or reticent and rarely talks on a personal level. Although this leads to her/him being perceived as seriously, it also means that she/he makes less use of individual relationships with others.`,
          `The participant only sometimes communicates self-confidence in social situations. She/he remains rather reserved and therefore seems to be less approachable. She/he usually lets others step into the spotlight and tends to hold back. Although this leads to her/him appearing serious, it also has the consequence that she/he is perceived as less present.`,
          `The participant conveyes an average level of self-confidence in social situations. Therefore, she/he keeps a balance between a reserved effect, in which she/he seems to be less approachable and situations in which she/he is perceived as outgoing. More self-confident communication could lead to an even stronger perception of presence, and networks being established and expanded more quickly.`,
          `The participant conveyes a high level of self-confidence in social situations, rarely holds back and does not allow herself/himself to be discouraged. With the help of self-confident communication, she/he quickly succeeds in reaching a personal level with others, creating presence and conveying social self-confidence.`,
          `The participant communicates very self-confident. She/he tends to put herself/himself in the centre of attention and is thus perceived as a self-confident communicator. She/he easily succeeds in establishing connections to others and forming networks. At the same time, a very high result may lead to others feeling pushed into the background.`,
        ],
      }
    },
    $precireDescriptions: function () {
      return [
        {
          key: 'Empathic',
          value: this.$i18n.translate(
            'The empathic style of communication conveys a high sensitivity to feelings other people. Communication is cautious and mindful of their feelings. The communication style conveys that in the position of the opposite is put into it. It becomes directly on the statements of the opponent responded sensitively to the feelings of other people.'
          ),
        },
        {
          key: 'Friendly',
          value: this.$i18n.translate(
            'The friendly style of communication expresses great closeness to other people and unfolds thereby a sympathetic and warm-hearted effect. It is signaled clear benevolence and great willingness to compromise. Friendly communicating persons look sympathetic, benevolent and warmhearted.'
          ),
        },
        {
          key: 'Supportive',
          value: this.$i18n.translate(
            'The supportive style of communication involves addressing the concerns of others encourage and help them to develop. Your own well-being stands not in the foreground. Who communicates supportive, speaks to others courage and conveys a great helpfulness. It shows understanding for others. Supportive communication requires helpfulness and seriousness Interest in the well-being of others.'
          ),
        },
        {
          key: 'Positive',
          value: this.$i18n.translate(
            'The positive communication style describes a positive and cheerful charisma, which leaves a pleasant mood.'
          ),
        },
        {
          key: 'Optimistic',
          value: this.$i18n.translate(
            'Confidence is conveyed in the optimistic style of communication. It creates a positive view of the future, even from negative Experiences positive conclusions and conveys that everything is possible. Due to the confident attitude, risks are assessed more positively and received earlier.'
          ),
        },
        {
          key: 'Visionary',
          value: this.$i18n.translate(
            'Employ people with a visionary style of communication often with a glorious future and meet auspicious statements. It is often about how even more can be achieved and how look for potential improvements. Visions are communicated to indicate positive expectations and a promising future.'
          ),
        },
        {
          key: 'Formal',
          value: this.$i18n.translate(
            'The formal communication style presents facts as objectively as possible. There is a lot of data, facts and figures describing what makes a rational, Fact-oriented and sober effect arises. Formal communication is always rational and fact-based.'
          ),
        },
        {
          key: 'Structured',
          value: this.$i18n.translate(
            'In the structured communication style, the individual statements build a narrative on each other. The communication follows a logical structure and has a common thread. This creates an organized effect. A common thread and a logical structure are signs of the structured communication style.'
          ),
        },
        {
          key: 'Goal-oriented',
          value: this.$i18n.translate(
            'Goal-oriented communication style becomes clear and unambiguous Statements made. Communication is as efficient and concise as possible, with the aim of finding a pragmatic solution. Goal-oriented communication requires clear, concise statements.'
          ),
        },
        {
          key: 'Goal_oriented',
          value: this.$i18n.translate(
            'Goal-oriented communication style becomes clear and unambiguous Statements made. Communication is as efficient and concise as possible, with the aim of finding a pragmatic solution. Goal-oriented communication requires clear, concise statements.'
          ),
        },
        {
          key: 'Reliable',
          value: this.$i18n.translate(
            'People who choose the reliable communication style convey a sense of obligation. It clearly states what responsibility is taken over and the interlocutor knows that the statements the opposite will be valid the next day as well. Reliable acts, who makes binding statements and takes responsibility.'
          ),
        },
        {
          key: 'Intellectual',
          value: this.$i18n.translate(
            'Intellectual communication style becomes a thoughtful one and created thoughtful effect. The language is precise and complex. Contents are described in detail and precisely. Overall will be such a high standard of performance. Intellectual communication is evidence of well thought-out precision and high complexity.'
          ),
        },
        {
          key: 'Unconventional',
          value: this.$i18n.translate(
            'Unconventional communication often means fancy, imaginative To bring ideas, innovative or unusual perspectives to open and to make generally surprising statements. Communication is unconventional through innovative and surprising elements.'
          ),
        },
        {
          key: 'Philosophical',
          value: this.$i18n.translate(
            'Philosophically communicating persons speak about the theoretical Backgrounds of their statements. They discuss philosophical and in-depth topics. Meaningful and in-depth discussions make communication seem philosophical.'
          ),
        },
        {
          key: 'Impulsive',
          value: this.$i18n.translate(
            "The impulsive style of communication is impatient, stormy or unsteady followed by a sudden impulse or inspiration rather than exactly. To consider and weigh the consequences of one's own statements. This quickly creates heated discussions. Communication is implicit when it is stormy and heated, Consequences are left out."
          ),
        },
        {
          key: 'Aggressive',
          value: this.$i18n.translate(
            'The aggressive style of communication is about an effervescent, relentless communication that exerts pressure on others and provoked the interlocutor or the person addressed. This conveys a high level of argumentation. Aggressively communicating persons are relentless and like to provoke in dicussions.'
          ),
        },
        {
          key: 'Authoritative',
          value: this.$i18n.translate(
            'The authoritarian style of communication determines which direction a communication takes. Authoritarian communicators set the tone and tend to take control in a conversation. Authoritarian communicates who sets the tone and likes to take control.'
          ),
        },
        {
          key: 'Self-confident',
          value: this.$i18n.translate(
            'Self-confidently communicating people tend to become the center of one to communicate. They rarely hold back, do not work reserved and difficult to discourage. If necessary, they also go into confrontation. Who confidently communicates, likes to be the center of attention and does not shy away from confrontation.'
          ),
        },
        {
          key: 'Self_confident',
          value: this.$i18n.translate(
            'Self-confidently communicating people tend to become the center of one to communicate. They rarely hold back, do not work reserved and difficult to discourage. If necessary, they also go into confrontation. Who confidently communicates, likes to be the center of attention and does not shy away from confrontation.'
          ),
        },
        {
          key: 'Composed',
          value: this.$i18n.translate(
            'Serene communication calms conversation situations sooner, than that it causes nervousness and excitement. Even in stressful situations the persons are still able to express themselves appropriately. Serene communicating people are rarely nervous and stressed, This allows you to choose your words even in difficult situations.'
          ),
        },
        {
          key: 'Dramatic',
          value: this.$i18n.translate(
            'Dramatizing communication means exaggerating, Embellish stories and events more interesting and more exciting than they really were. Dramatizing communication means exaggerating.'
          ),
        },
        {
          key: 'Motivating',
          value: this.$i18n.translate(
            'The motivational style of communication conveys enthusiasm and activity. With this effect, it is easier to enthrall listeners and inspire them. Conversations or texts are experienced rather as exciting. Communication is motivating when listeners of Enthusiasm and activity are carried away.'
          ),
        },
        {
          key: 'Impressive',
          value: this.$i18n.translate(
            'The impressive communication style is captivating and leaves a lasting impression on other people.'
          ),
        },
        {
          key: 'Independent',
          value: this.$i18n.translate(
            'Independent communication means making statements independent of common beliefs and meet other people. People who communicate independently, do not secure the acceptance of their statements in others. They settle in that, what they say, not the prevailing opinion or the supposed one to influence the judgments of others.'
          ),
        },
        {
          key: 'Cooperative',
          value: this.$i18n.translate(
            'Cooperative communication means friendly to its interlocutorsto be sensitive to their feelings and sensitive to them.People with high scores do not just put themselves in the position of theirsBut also encourage and support him.They convey a great willingness to help others.'
          ),
        },
        {
          key: 'Venturing',
          value: this.$i18n.translate(
            'Entrepreneurial communication also means something that has not yet been fully assessedTo call ventures and spread a confident mood. It will botha positive mood in the current situation as well as an optimistic oneA look ahead to the future. Positive experiences from the past providefor a good mood and a high degree of confidence that the future will be glorious tooWill bring good. It creates visions of this promising future and a concrete idea of how even more can be achieved.'
          ),
        },
        {
          key: 'Professional',
          value: this.$i18n.translate(
            'Professional implies a structured conversation in which thebuild up individual parts of a narrative. It is based on an objectiveand rational representation respected. It becomes clear and unambiguous statementsmade and communicated efficiently, creating a high level of commitment in theStatements arise. The effect is often intellectual, as it is exactlydescribes what is meant and high standards of performance are taught.'
          ),
        },
        {
          key: 'Innovative',
          value: this.$i18n.translate(
            'Innovative communication conveys a great interest in deep topics,theoretical backgrounds and philosophical talks. It will be in conversationsoften made surprising and innovative statements that open up new perspectives.'
          ),
        },
        {
          key: 'Competitive',
          value: this.$i18n.translate(
            'Competitive communication means an emotional and restless way.The great impatience often results in heated discussions,it is provoked, argued and often put pressure on others.The communicating person is relentless and quick-tempered.'
          ),
        },
        {
          key: 'Directing',
          value: this.$i18n.translate(
            'Steering communication means a strong tendency to take control of oneCommunication situation to take over, control and specify the tone.People with high scores find it hard to hold back,they are more in the focus. Instead of tense,To be nervous or restless, they are also in critical situationsrelaxed and confident.'
          ),
        },
        {
          key: 'Dramatic',
          value: this.$i18n.translate(
            'Dramatizing communication means exaggerating storiesto embellish and events more interesting and excitingto represent when they were in reality.'
          ),
        },
        {
          key: 'Inspiring',
          value: this.$i18n.translate(
            'Inspirational communication means unfolding a captivating impact which leaves a lasting impression on the audience.This succeeds in inspiring, inspiring and motivating others.'
          ),
        },
        {
          key: 'Independent',
          value: this.$i18n.translate(
            'Independent communication means making statements independent of common beliefsand meet other people. People who communicate independently,do not secure the acceptance of their statements in others. They settle in that,what they say, not the prevailing opinion or the supposed oneTo influence the judgments of others.'
          ),
        },
      ]
    },
    $dummyPrecire() {
      return [
        {
          slNo: 1,
          results: 'positive',
          resultDetails: [
            {
              score: 0,
              percentile: 46,
            },
          ],
        },
        {
          slNo: 2,
          results: 'reliable',
          resultDetails: [
            {
              score: 0,
              percentile: 61,
            },
          ],
        },
        {
          slNo: 3,
          results: 'supportive',
          resultDetails: [
            {
              score: 0,
              percentile: 29,
            },
          ],
        },
        {
          slNo: 4,
          results: 'impressive',
          resultDetails: [
            {
              score: 0,
              percentile: 26,
            },
          ],
        },
        {
          slNo: 4,
          results: 'friendly',
          resultDetails: [
            {
              score: 0,
              percentile: 57,
            },
          ],
        },
        {
          slNo: 4,
          results: 'venturing',
          resultDetails: [
            {
              score: 0,
              percentile: 43,
            },
          ],
        },
        {
          slNo: 4,
          results: 'impulsive',
          resultDetails: [
            {
              score: 0,
              percentile: 67,
            },
          ],
        },
        {
          slNo: 4,
          results: 'competitive',
          resultDetails: [
            {
              score: 0,
              percentile: 42,
            },
          ],
        },
        {
          slNo: 4,
          results: 'composed',
          resultDetails: [
            {
              score: 0,
              percentile: 83,
            },
          ],
        },
        {
          slNo: 4,
          results: 'professional',
          resultDetails: [
            {
              score: 0,
              percentile: 26,
            },
          ],
        },
        {
          slNo: 4,
          results: 'innovative',
          resultDetails: [
            {
              score: 0,
              percentile: 10,
            },
          ],
        },
        {
          slNo: 4,
          results: 'aggressive',
          resultDetails: [
            {
              score: 0,
              percentile: 56,
            },
          ],
        },
        {
          slNo: 4,
          results: 'self_confident',
          resultDetails: [
            {
              score: 0,
              percentile: 6,
            },
          ],
        },
        {
          slNo: 4,
          results: 'authoritative',
          resultDetails: [
            {
              score: 0,
              percentile: 40,
            },
          ],
        },
        {
          slNo: 4,
          results: 'visionary',
          resultDetails: [
            {
              score: 0,
              percentile: 65,
            },
          ],
        },
        {
          slNo: 4,
          results: 'empathic',
          resultDetails: [
            {
              score: 0,
              percentile: 43,
            },
          ],
        },
        {
          slNo: 4,
          results: 'optimistic',
          resultDetails: [
            {
              score: 0,
              percentile: 39,
            },
          ],
        },
        {
          slNo: 4,
          results: 'unconventional',
          resultDetails: [
            {
              score: 0,
              percentile: 69,
            },
          ],
        },
        {
          slNo: 4,
          results: 'structured',
          resultDetails: [
            {
              score: 0,
              percentile: 10,
            },
          ],
        },
        {
          slNo: 4,
          results: 'dramatic',
          resultDetails: [
            {
              score: 0,
              percentile: 33,
            },
          ],
        },
        {
          slNo: 4,
          results: 'motivating',
          resultDetails: [
            {
              score: 0,
              percentile: 60,
            },
          ],
        },
        {
          slNo: 4,
          results: 'inspiring',
          resultDetails: [
            {
              score: 0,
              percentile: 31,
            },
          ],
        },
        {
          slNo: 4,
          results: 'directing',
          resultDetails: [
            {
              score: 0,
              percentile: 19,
            },
          ],
        },
        {
          slNo: 4,
          results: 'formal',
          resultDetails: [
            {
              score: 0,
              percentile: 16,
            },
          ],
        },
        {
          slNo: 4,
          results: 'intellectual',
          resultDetails: [
            {
              score: 0,
              percentile: 7,
            },
          ],
        },
        {
          slNo: 4,
          results: 'goal_oriented',
          resultDetails: [
            {
              score: 0,
              percentile: 98,
            },
          ],
        },
        {
          slNo: 4,
          results: 'philosophical',
          resultDetails: [
            {
              score: 0,
              percentile: 0,
            },
          ],
        },
        {
          slNo: 4,
          results: 'cooperative',
          resultDetails: [
            {
              score: 0,
              percentile: 21,
            },
          ],
        },
        {
          slNo: 4,
          results: 'independent',
          resultDetails: [
            {
              score: 0,
              percentile: 85,
            },
          ],
        },
      ]
    },
    $precireOptimalValues() {
      return {
        'Customer Service': [
          { precireResult: 'Positive', optimalValue: 10 },
          { precireResult: 'Reliable', optimalValue: 8 },
          { precireResult: 'Supportive', optimalValue: 10 },
          { precireResult: 'Professional', optimalValue: 8 },
          { precireResult: 'Directing', optimalValue: 6 },
          { precireResult: 'Formal', optimalValue: 7 },
          { precireResult: 'Cooperative', optimalValue: 9 },
          { precireResult: 'Intellectual', optimalValue: 6 },
          { precireResult: 'Competitive', optimalValue: 6 },
          { precireResult: 'Self Confident', optimalValue: 9 },
          { precireResult: 'Empathic', optimalValue: 10 },
          { precireResult: 'Structured', optimalValue: 8 },
          { precireResult: 'Venturing', optimalValue: 4 },
          { precireResult: 'Independent', optimalValue: 6 },
          { precireResult: 'Visionary', optimalValue: 5 },
          { precireResult: 'Innovative', optimalValue: 7 },
          { precireResult: 'Aggressive', optimalValue: 3 },
          { precireResult: 'Goal Oriented', optimalValue: 8 },
          { precireResult: 'Inspiring', optimalValue: 8 },
          { precireResult: 'Authoritative', optimalValue: 6 },
          { precireResult: 'Impressive', optimalValue: 8 },
          { precireResult: 'Impulsive', optimalValue: 4 },
          { precireResult: 'Optimistic', optimalValue: 10 },
          { precireResult: 'Philosophical', optimalValue: 5 },
          { precireResult: 'Dramatic', optimalValue: 2 },
          { precireResult: 'Unconventional', optimalValue: 6 },
          { precireResult: 'Motivating', optimalValue: 9 },
          { precireResult: 'Friendly', optimalValue: 10 },
          { precireResult: 'Composed', optimalValue: 8 },
        ],
        Administration: [
          { precireResult: 'Positive', optimalValue: 7 },
          { precireResult: 'Reliable', optimalValue: 9 },
          { precireResult: 'Supportive', optimalValue: 8 },
          { precireResult: 'Professional', optimalValue: 8 },
          { precireResult: 'Directing', optimalValue: 6 },
          { precireResult: 'Formal', optimalValue: 7 },
          { precireResult: 'Cooperative', optimalValue: 9 },
          { precireResult: 'Intellectual', optimalValue: 7 },
          { precireResult: 'Competitive', optimalValue: 5 },
          { precireResult: 'Self Confident', optimalValue: 6 },
          { precireResult: 'Empathic', optimalValue: 7 },
          { precireResult: 'Structured', optimalValue: 10 },
          { precireResult: 'Venturing', optimalValue: 4 },
          { precireResult: 'Independent', optimalValue: 6 },
          { precireResult: 'Visionary', optimalValue: 4 },
          { precireResult: 'Innovative', optimalValue: 5 },
          { precireResult: 'Aggressive', optimalValue: 3 },
          { precireResult: 'Goal Oriented', optimalValue: 8 },
          { precireResult: 'Inspiring', optimalValue: 6 },
          { precireResult: 'Authoritative', optimalValue: 5 },
          { precireResult: 'Impressive', optimalValue: 5 },
          { precireResult: 'Impulsive', optimalValue: 2 },
          { precireResult: 'Optimistic', optimalValue: 6 },
          { precireResult: 'Philosophical', optimalValue: 4 },
          { precireResult: 'Dramatic', optimalValue: 3 },
          { precireResult: 'Unconventional', optimalValue: 4 },
          { precireResult: 'Motivating', optimalValue: 7 },
          { precireResult: 'Friendly', optimalValue: 8 },
          { precireResult: 'Composed', optimalValue: 9 },
        ],
        'Education And Training': [
          { precireResult: 'Positive', optimalValue: 9 },
          { precireResult: 'Reliable', optimalValue: 8 },
          { precireResult: 'Supportive', optimalValue: 10 },
          { precireResult: 'Professional', optimalValue: 8 },
          { precireResult: 'Directing', optimalValue: 8 },
          { precireResult: 'Formal', optimalValue: 6 },
          { precireResult: 'Cooperative', optimalValue: 9 },
          { precireResult: 'Intellectual', optimalValue: 10 },
          { precireResult: 'Competitive', optimalValue: 6 },
          { precireResult: 'Self Confident', optimalValue: 8 },
          { precireResult: 'Empathic', optimalValue: 10 },
          { precireResult: 'Structured', optimalValue: 8 },
          { precireResult: 'Venturing', optimalValue: 7 },
          { precireResult: 'Independent', optimalValue: 7 },
          { precireResult: 'Visionary', optimalValue: 4 },
          { precireResult: 'Innovative', optimalValue: 8 },
          { precireResult: 'Aggressive', optimalValue: 3 },
          { precireResult: 'Goal Oriented', optimalValue: 8 },
          { precireResult: 'Inspiring', optimalValue: 10 },
          { precireResult: 'Authoritative', optimalValue: 7 },
          { precireResult: 'Impressive', optimalValue: 7 },
          { precireResult: 'Impulsive', optimalValue: 4 },
          { precireResult: 'Optimistic', optimalValue: 9 },
          { precireResult: 'Philosophical', optimalValue: 8 },
          { precireResult: 'Dramatic', optimalValue: 5 },
          { precireResult: 'Unconventional', optimalValue: 3 },
          { precireResult: 'Motivating', optimalValue: 10 },
          { precireResult: 'Friendly', optimalValue: 10 },
          { precireResult: 'Composed', optimalValue: 8 },
        ],
        'Design And Layout': [
          { precireResult: 'Positive', optimalValue: 8 },
          { precireResult: 'Reliable', optimalValue: 7 },
          { precireResult: 'Supportive', optimalValue: 7 },
          { precireResult: 'Professional', optimalValue: 8 },
          { precireResult: 'Directing', optimalValue: 6 },
          { precireResult: 'Formal', optimalValue: 6 },
          { precireResult: 'Cooperative', optimalValue: 8 },
          { precireResult: 'Intellectual', optimalValue: 8 },
          { precireResult: 'Competitive', optimalValue: 7 },
          { precireResult: 'Self Confident', optimalValue: 9 },
          { precireResult: 'Empathic', optimalValue: 6 },
          { precireResult: 'Structured', optimalValue: 7 },
          { precireResult: 'Venturing', optimalValue: 8 },
          { precireResult: 'Independent', optimalValue: 9 },
          { precireResult: 'Visionary', optimalValue: 10 },
          { precireResult: 'Innovative', optimalValue: 10 },
          { precireResult: 'Aggressive', optimalValue: 4 },
          { precireResult: 'Goal Oriented', optimalValue: 9 },
          { precireResult: 'Inspiring', optimalValue: 9 },
          { precireResult: 'Authoritative', optimalValue: 6 },
          { precireResult: 'Impressive', optimalValue: 9 },
          { precireResult: 'Impulsive', optimalValue: 5 },
          { precireResult: 'Optimistic', optimalValue: 8 },
          { precireResult: 'Philosophical', optimalValue: 7 },
          { precireResult: 'Dramatic', optimalValue: 7 },
          { precireResult: 'Unconventional', optimalValue: 10 },
          { precireResult: 'Motivating', optimalValue: 7 },
          { precireResult: 'Friendly', optimalValue: 8 },
          { precireResult: 'Composed', optimalValue: 7 },
        ],
        'Craft Trades': [
          { precireResult: 'Positive', optimalValue: 7 },
          { precireResult: 'Reliable', optimalValue: 9 },
          { precireResult: 'Supportive', optimalValue: 7 },
          { precireResult: 'Professional', optimalValue: 8 },
          { precireResult: 'Directing', optimalValue: 6 },
          { precireResult: 'Formal', optimalValue: 6 },
          { precireResult: 'Cooperative', optimalValue: 8 },
          { precireResult: 'Intellectual', optimalValue: 6 },
          { precireResult: 'Competitive', optimalValue: 6 },
          { precireResult: 'Self Confident', optimalValue: 8 },
          { precireResult: 'Empathic', optimalValue: 6 },
          { precireResult: 'Structured', optimalValue: 8 },
          { precireResult: 'Venturing', optimalValue: 7 },
          { precireResult: 'Independent', optimalValue: 9 },
          { precireResult: 'Visionary', optimalValue: 5 },
          { precireResult: 'Innovative', optimalValue: 7 },
          { precireResult: 'Aggressive', optimalValue: 4 },
          { precireResult: 'Goal Oriented', optimalValue: 9 },
          { precireResult: 'Inspiring', optimalValue: 6 },
          { precireResult: 'Authoritative', optimalValue: 6 },
          { precireResult: 'Impressive', optimalValue: 7 },
          { precireResult: 'Impulsive', optimalValue: 3 },
          { precireResult: 'Optimistic', optimalValue: 7 },
          { precireResult: 'Philosophical', optimalValue: 4 },
          { precireResult: 'Dramatic', optimalValue: 3 },
          { precireResult: 'Unconventional', optimalValue: 5 },
          { precireResult: 'Motivating', optimalValue: 7 },
          { precireResult: 'Friendly', optimalValue: 8 },
          { precireResult: 'Composed', optimalValue: 7 },
        ],
        'Hotel And Catering': [
          { precireResult: 'Positive', optimalValue: 10 },
          { precireResult: 'Reliable', optimalValue: 8 },
          { precireResult: 'Supportive', optimalValue: 9 },
          { precireResult: 'Professional', optimalValue: 9 },
          { precireResult: 'Directing', optimalValue: 8 },
          { precireResult: 'Formal', optimalValue: 8 },
          { precireResult: 'Cooperative', optimalValue: 10 },
          { precireResult: 'Intellectual', optimalValue: 6 },
          { precireResult: 'Competitive', optimalValue: 7 },
          { precireResult: 'Self Confident', optimalValue: 9 },
          { precireResult: 'Empathic', optimalValue: 10 },
          { precireResult: 'Structured', optimalValue: 8 },
          { precireResult: 'Venturing', optimalValue: 7 },
          { precireResult: 'Independent', optimalValue: 7 },
          { precireResult: 'Visionary', optimalValue: 6 },
          { precireResult: 'Innovative', optimalValue: 7 },
          { precireResult: 'Aggressive', optimalValue: 3 },
          { precireResult: 'Goal Oriented', optimalValue: 9 },
          { precireResult: 'Inspiring', optimalValue: 5 },
          { precireResult: 'Authoritative', optimalValue: 7 },
          { precireResult: 'Impressive', optimalValue: 6 },
          { precireResult: 'Impulsive', optimalValue: 3 },
          { precireResult: 'Optimistic', optimalValue: 10 },
          { precireResult: 'Philosophical', optimalValue: 2 },
          { precireResult: 'Dramatic', optimalValue: 3 },
          { precireResult: 'Unconventional', optimalValue: 7 },
          { precireResult: 'Motivating', optimalValue: 9 },
          { precireResult: 'Friendly', optimalValue: 10 },
          { precireResult: 'Composed', optimalValue: 8 },
        ],
        'Engineering/Development And Construction': [
          { precireResult: 'Positive', optimalValue: 5 },
          { precireResult: 'Reliable', optimalValue: 9 },
          { precireResult: 'Supportive', optimalValue: 7 },
          { precireResult: 'Professional', optimalValue: 9 },
          { precireResult: 'Directing', optimalValue: 8 },
          { precireResult: 'Formal', optimalValue: 8 },
          { precireResult: 'Cooperative', optimalValue: 8 },
          { precireResult: 'Intellectual', optimalValue: 10 },
          { precireResult: 'Competitive', optimalValue: 8 },
          { precireResult: 'Self Confident', optimalValue: 8 },
          { precireResult: 'Empathic', optimalValue: 4 },
          { precireResult: 'Structured', optimalValue: 10 },
          { precireResult: 'Venturing', optimalValue: 7 },
          { precireResult: 'Independent', optimalValue: 9 },
          { precireResult: 'Visionary', optimalValue: 8 },
          { precireResult: 'Innovative', optimalValue: 9 },
          { precireResult: 'Aggressive', optimalValue: 4 },
          { precireResult: 'Goal Oriented', optimalValue: 9 },
          { precireResult: 'Inspiring', optimalValue: 7 },
          { precireResult: 'Authoritative', optimalValue: 8 },
          { precireResult: 'Impressive', optimalValue: 8 },
          { precireResult: 'Impulsive', optimalValue: 3 },
          { precireResult: 'Optimistic', optimalValue: 7 },
          { precireResult: 'Philosophical', optimalValue: 3 },
          { precireResult: 'Dramatic', optimalValue: 3 },
          { precireResult: 'Unconventional', optimalValue: 7 },
          { precireResult: 'Motivating', optimalValue: 7 },
          { precireResult: 'Friendly', optimalValue: 7 },
          { precireResult: 'Composed', optimalValue: 8 },
        ],
        Maintenance: [
          { precireResult: 'Positive', optimalValue: 5 },
          { precireResult: 'Reliable', optimalValue: 10 },
          { precireResult: 'Supportive', optimalValue: 8 },
          { precireResult: 'Professional', optimalValue: 9 },
          { precireResult: 'Directing', optimalValue: 7 },
          { precireResult: 'Formal', optimalValue: 8 },
          { precireResult: 'Cooperative', optimalValue: 9 },
          { precireResult: 'Intellectual', optimalValue: 7 },
          { precireResult: 'Competitive', optimalValue: 7 },
          { precireResult: 'Self Confident', optimalValue: 8 },
          { precireResult: 'Empathic', optimalValue: 7 },
          { precireResult: 'Structured', optimalValue: 10 },
          { precireResult: 'Venturing', optimalValue: 6 },
          { precireResult: 'Independent', optimalValue: 8 },
          { precireResult: 'Visionary', optimalValue: 5 },
          { precireResult: 'Innovative', optimalValue: 8 },
          { precireResult: 'Aggressive', optimalValue: 3 },
          { precireResult: 'Goal Oriented', optimalValue: 10 },
          { precireResult: 'Inspiring', optimalValue: 7 },
          { precireResult: 'Authoritative', optimalValue: 8 },
          { precireResult: 'Impressive', optimalValue: 7 },
          { precireResult: 'Impulsive', optimalValue: 3 },
          { precireResult: 'Optimistic', optimalValue: 7 },
          { precireResult: 'Philosophical', optimalValue: 6 },
          { precireResult: 'Dramatic', optimalValue: 2 },
          { precireResult: 'Unconventional', optimalValue: 3 },
          { precireResult: 'Motivating', optimalValue: 8 },
          { precireResult: 'Friendly', optimalValue: 8 },
          { precireResult: 'Composed', optimalValue: 9 },
        ],
        'IT Information Technology': [
          { precireResult: 'Positive', optimalValue: 6 },
          { precireResult: 'Reliable', optimalValue: 9 },
          { precireResult: 'Supportive', optimalValue: 6 },
          { precireResult: 'Professional', optimalValue: 9 },
          { precireResult: 'Directing', optimalValue: 8 },
          { precireResult: 'Formal', optimalValue: 7 },
          { precireResult: 'Cooperative', optimalValue: 8 },
          { precireResult: 'Intellectual', optimalValue: 10 },
          { precireResult: 'Competitive', optimalValue: 8 },
          { precireResult: 'Self Confident', optimalValue: 7 },
          { precireResult: 'Empathic', optimalValue: 3 },
          { precireResult: 'Structured', optimalValue: 10 },
          { precireResult: 'Venturing', optimalValue: 5 },
          { precireResult: 'Independent', optimalValue: 9 },
          { precireResult: 'Visionary', optimalValue: 8 },
          { precireResult: 'Innovative', optimalValue: 10 },
          { precireResult: 'Aggressive', optimalValue: 2 },
          { precireResult: 'Goal Oriented', optimalValue: 9 },
          { precireResult: 'Inspiring', optimalValue: 7 },
          { precireResult: 'Authoritative', optimalValue: 8 },
          { precireResult: 'Impressive', optimalValue: 8 },
          { precireResult: 'Impulsive', optimalValue: 2 },
          { precireResult: 'Optimistic', optimalValue: 7 },
          { precireResult: 'Philosophical', optimalValue: 7 },
          { precireResult: 'Dramatic', optimalValue: 3 },
          { precireResult: 'Unconventional', optimalValue: 8 },
          { precireResult: 'Motivating', optimalValue: 7 },
          { precireResult: 'Friendly', optimalValue: 4 },
          { precireResult: 'Composed', optimalValue: 8 },
        ],
        'Logistics And Transport': [
          { precireResult: 'Positive', optimalValue: 7 },
          { precireResult: 'Reliable', optimalValue: 9 },
          { precireResult: 'Supportive', optimalValue: 5 },
          { precireResult: 'Professional', optimalValue: 8 },
          { precireResult: 'Directing', optimalValue: 5 },
          { precireResult: 'Formal', optimalValue: 8 },
          { precireResult: 'Cooperative', optimalValue: 9 },
          { precireResult: 'Intellectual', optimalValue: 7 },
          { precireResult: 'Competitive', optimalValue: 8 },
          { precireResult: 'Self Confident', optimalValue: 8 },
          { precireResult: 'Empathic', optimalValue: 6 },
          { precireResult: 'Structured', optimalValue: 10 },
          { precireResult: 'Venturing', optimalValue: 7 },
          { precireResult: 'Independent', optimalValue: 8 },
          { precireResult: 'Visionary', optimalValue: 7 },
          { precireResult: 'Innovative', optimalValue: 7 },
          { precireResult: 'Aggressive', optimalValue: 2 },
          { precireResult: 'Goal Oriented', optimalValue: 10 },
          { precireResult: 'Inspiring', optimalValue: 7 },
          { precireResult: 'Authoritative', optimalValue: 8 },
          { precireResult: 'Impressive', optimalValue: 8 },
          { precireResult: 'Impulsive', optimalValue: 3 },
          { precireResult: 'Optimistic', optimalValue: 8 },
          { precireResult: 'Philosophical', optimalValue: 2 },
          { precireResult: 'Dramatic', optimalValue: 3 },
          { precireResult: 'Unconventional', optimalValue: 6 },
          { precireResult: 'Motivating', optimalValue: 8 },
          { precireResult: 'Friendly', optimalValue: 8 },
          { precireResult: 'Composed', optimalValue: 9 },
        ],
        Marketing: [
          { precireResult: 'Positive', optimalValue: 9 },
          { precireResult: 'Reliable', optimalValue: 8 },
          { precireResult: 'Supportive', optimalValue: 3 },
          { precireResult: 'Professional', optimalValue: 8 },
          { precireResult: 'Directing', optimalValue: 7 },
          { precireResult: 'Formal', optimalValue: 7 },
          { precireResult: 'Cooperative', optimalValue: 8 },
          { precireResult: 'Intellectual', optimalValue: 7 },
          { precireResult: 'Competitive', optimalValue: 9 },
          { precireResult: 'Self Confident', optimalValue: 9 },
          { precireResult: 'Empathic', optimalValue: 7 },
          { precireResult: 'Structured', optimalValue: 8 },
          { precireResult: 'Venturing', optimalValue: 9 },
          { precireResult: 'Independent', optimalValue: 6 },
          { precireResult: 'Visionary', optimalValue: 9 },
          { precireResult: 'Innovative', optimalValue: 9 },
          { precireResult: 'Aggressive', optimalValue: 6 },
          { precireResult: 'Goal Oriented', optimalValue: 9 },
          { precireResult: 'Inspiring', optimalValue: 9 },
          { precireResult: 'Authoritative', optimalValue: 6 },
          { precireResult: 'Impressive', optimalValue: 9 },
          { precireResult: 'Impulsive', optimalValue: 6 },
          { precireResult: 'Optimistic', optimalValue: 9 },
          { precireResult: 'Philosophical', optimalValue: 3 },
          { precireResult: 'Dramatic', optimalValue: 3 },
          { precireResult: 'Unconventional', optimalValue: 9 },
          { precireResult: 'Motivating', optimalValue: 9 },
          { precireResult: 'Friendly', optimalValue: 8 },
          { precireResult: 'Composed', optimalValue: 6 },
        ],
        'Medicine And Health': [
          { precireResult: 'Positive', optimalValue: 8 },
          { precireResult: 'Reliable', optimalValue: 9 },
          { precireResult: 'Supportive', optimalValue: 9 },
          { precireResult: 'Professional', optimalValue: 9 },
          { precireResult: 'Directing', optimalValue: 6 },
          { precireResult: 'Formal', optimalValue: 8 },
          { precireResult: 'Cooperative', optimalValue: 9 },
          { precireResult: 'Intellectual', optimalValue: 10 },
          { precireResult: 'Competitive', optimalValue: 6 },
          { precireResult: 'Self Confident', optimalValue: 9 },
          { precireResult: 'Empathic', optimalValue: 10 },
          { precireResult: 'Structured', optimalValue: 9 },
          { precireResult: 'Venturing', optimalValue: 6 },
          { precireResult: 'Independent', optimalValue: 8 },
          { precireResult: 'Visionary', optimalValue: 7 },
          { precireResult: 'Innovative', optimalValue: 7 },
          { precireResult: 'Aggressive', optimalValue: 3 },
          { precireResult: 'Goal Oriented', optimalValue: 10 },
          { precireResult: 'Inspiring', optimalValue: 8 },
          { precireResult: 'Authoritative', optimalValue: 6 },
          { precireResult: 'Impressive', optimalValue: 7 },
          { precireResult: 'Impulsive', optimalValue: 3 },
          { precireResult: 'Optimistic', optimalValue: 8 },
          { precireResult: 'Philosophical', optimalValue: 8 },
          { precireResult: 'Dramatic', optimalValue: 2 },
          { precireResult: 'Unconventional', optimalValue: 5 },
          { precireResult: 'Motivating', optimalValue: 8 },
          { precireResult: 'Friendly', optimalValue: 9 },
          { precireResult: 'Composed', optimalValue: 9 },
        ],
        'Scientific Research': [
          { precireResult: 'Positive', optimalValue: 7 },
          { precireResult: 'Reliable', optimalValue: 9 },
          { precireResult: 'Supportive', optimalValue: 6 },
          { precireResult: 'Professional', optimalValue: 9 },
          { precireResult: 'Directing', optimalValue: 8 },
          { precireResult: 'Formal', optimalValue: 7 },
          { precireResult: 'Cooperative', optimalValue: 8 },
          { precireResult: 'Intellectual', optimalValue: 10 },
          { precireResult: 'Competitive', optimalValue: 7 },
          { precireResult: 'Self Confident', optimalValue: 8 },
          { precireResult: 'Empathic', optimalValue: 6 },
          { precireResult: 'Structured', optimalValue: 10 },
          { precireResult: 'Venturing', optimalValue: 7 },
          { precireResult: 'Independent', optimalValue: 9 },
          { precireResult: 'Visionary', optimalValue: 9 },
          { precireResult: 'Innovative', optimalValue: 10 },
          { precireResult: 'Aggressive', optimalValue: 3 },
          { precireResult: 'Goal Oriented', optimalValue: 9 },
          { precireResult: 'Inspiring', optimalValue: 7 },
          { precireResult: 'Authoritative', optimalValue: 8 },
          { precireResult: 'Impressive', optimalValue: 8 },
          { precireResult: 'Impulsive', optimalValue: 3 },
          { precireResult: 'Optimistic', optimalValue: 7 },
          { precireResult: 'Philosophical', optimalValue: 9 },
          { precireResult: 'Dramatic', optimalValue: 3 },
          { precireResult: 'Unconventional', optimalValue: 8 },
          { precireResult: 'Motivating', optimalValue: 7 },
          { precireResult: 'Friendly', optimalValue: 6 },
          { precireResult: 'Composed', optimalValue: 8 },
        ],
        'Human Resources': [
          { precireResult: 'Positive', optimalValue: 9 },
          { precireResult: 'Reliable', optimalValue: 9 },
          { precireResult: 'Supportive', optimalValue: 10 },
          { precireResult: 'Professional', optimalValue: 9 },
          { precireResult: 'Directing', optimalValue: 8 },
          { precireResult: 'Formal', optimalValue: 8 },
          { precireResult: 'Cooperative', optimalValue: 10 },
          { precireResult: 'Intellectual', optimalValue: 8 },
          { precireResult: 'Competitive', optimalValue: 7 },
          { precireResult: 'Self Confident', optimalValue: 8 },
          { precireResult: 'Empathic', optimalValue: 10 },
          { precireResult: 'Structured', optimalValue: 8 },
          { precireResult: 'Venturing', optimalValue: 6 },
          { precireResult: 'Independent', optimalValue: 7 },
          { precireResult: 'Visionary', optimalValue: 7 },
          { precireResult: 'Innovative', optimalValue: 8 },
          { precireResult: 'Aggressive', optimalValue: 4 },
          { precireResult: 'Goal Oriented', optimalValue: 9 },
          { precireResult: 'Inspiring', optimalValue: 9 },
          { precireResult: 'Authoritative', optimalValue: 9 },
          { precireResult: 'Impressive', optimalValue: 8 },
          { precireResult: 'Impulsive', optimalValue: 3 },
          { precireResult: 'Optimistic', optimalValue: 9 },
          { precireResult: 'Philosophical', optimalValue: 7 },
          { precireResult: 'Dramatic', optimalValue: 3 },
          { precireResult: 'Unconventional', optimalValue: 7 },
          { precireResult: 'Motivating', optimalValue: 9 },
          { precireResult: 'Friendly', optimalValue: 9 },
          { precireResult: 'Composed', optimalValue: 9 },
        ],
        Production: [
          { precireResult: 'Positive', optimalValue: 5 },
          { precireResult: 'Reliable', optimalValue: 10 },
          { precireResult: 'Supportive', optimalValue: 8 },
          { precireResult: 'Professional', optimalValue: 9 },
          { precireResult: 'Directing', optimalValue: 7 },
          { precireResult: 'Formal', optimalValue: 7 },
          { precireResult: 'Cooperative', optimalValue: 9 },
          { precireResult: 'Intellectual', optimalValue: 7 },
          { precireResult: 'Competitive', optimalValue: 8 },
          { precireResult: 'Self Confident', optimalValue: 8 },
          { precireResult: 'Empathic', optimalValue: 6 },
          { precireResult: 'Structured', optimalValue: 10 },
          { precireResult: 'Venturing', optimalValue: 7 },
          { precireResult: 'Independent', optimalValue: 8 },
          { precireResult: 'Visionary', optimalValue: 4 },
          { precireResult: 'Innovative', optimalValue: 6 },
          { precireResult: 'Aggressive', optimalValue: 3 },
          { precireResult: 'Goal Oriented', optimalValue: 10 },
          { precireResult: 'Inspiring', optimalValue: 7 },
          { precireResult: 'Authoritative', optimalValue: 7 },
          { precireResult: 'Impressive', optimalValue: 8 },
          { precireResult: 'Impulsive', optimalValue: 3 },
          { precireResult: 'Optimistic', optimalValue: 7 },
          { precireResult: 'Philosophical', optimalValue: 3 },
          { precireResult: 'Dramatic', optimalValue: 2 },
          { precireResult: 'Unconventional', optimalValue: 6 },
          { precireResult: 'Motivating', optimalValue: 8 },
          { precireResult: 'Friendly', optimalValue: 8 },
          { precireResult: 'Composed', optimalValue: 9 },
        ],
        'Project Management': [
          { precireResult: 'Positive', optimalValue: 8 },
          { precireResult: 'Reliable', optimalValue: 9 },
          { precireResult: 'Supportive', optimalValue: 7 },
          { precireResult: 'Professional', optimalValue: 9 },
          { precireResult: 'Directing', optimalValue: 9 },
          { precireResult: 'Formal', optimalValue: 7 },
          { precireResult: 'Cooperative', optimalValue: 9 },
          { precireResult: 'Intellectual', optimalValue: 8 },
          { precireResult: 'Competitive', optimalValue: 8 },
          { precireResult: 'Self Confident', optimalValue: 9 },
          { precireResult: 'Empathic', optimalValue: 4 },
          { precireResult: 'Structured', optimalValue: 10 },
          { precireResult: 'Venturing', optimalValue: 7 },
          { precireResult: 'Independent', optimalValue: 9 },
          { precireResult: 'Visionary', optimalValue: 8 },
          { precireResult: 'Innovative', optimalValue: 8 },
          { precireResult: 'Aggressive', optimalValue: 3 },
          { precireResult: 'Goal Oriented', optimalValue: 10 },
          { precireResult: 'Inspiring', optimalValue: 9 },
          { precireResult: 'Authoritative', optimalValue: 9 },
          { precireResult: 'Impressive', optimalValue: 8 },
          { precireResult: 'Impulsive', optimalValue: 2 },
          { precireResult: 'Optimistic', optimalValue: 8 },
          { precireResult: 'Philosophical', optimalValue: 3 },
          { precireResult: 'Dramatic', optimalValue: 3 },
          { precireResult: 'Unconventional', optimalValue: 7 },
          { precireResult: 'Motivating', optimalValue: 9 },
          { precireResult: 'Friendly', optimalValue: 8 },
          { precireResult: 'Composed', optimalValue: 8 },
        ],
        'Quality Management': [
          { precireResult: 'Positive', optimalValue: 7 },
          { precireResult: 'Reliable', optimalValue: 10 },
          { precireResult: 'Supportive', optimalValue: 8 },
          { precireResult: 'Professional', optimalValue: 9 },
          { precireResult: 'Directing', optimalValue: 7 },
          { precireResult: 'Formal', optimalValue: 8 },
          { precireResult: 'Cooperative', optimalValue: 9 },
          { precireResult: 'Intellectual', optimalValue: 7 },
          { precireResult: 'Competitive', optimalValue: 7 },
          { precireResult: 'Self Confident', optimalValue: 8 },
          { precireResult: 'Empathic', optimalValue: 7 },
          { precireResult: 'Structured', optimalValue: 10 },
          { precireResult: 'Venturing', optimalValue: 7 },
          { precireResult: 'Independent', optimalValue: 8 },
          { precireResult: 'Visionary', optimalValue: 7 },
          { precireResult: 'Innovative', optimalValue: 8 },
          { precireResult: 'Aggressive', optimalValue: 3 },
          { precireResult: 'Goal Oriented', optimalValue: 10 },
          { precireResult: 'Inspiring', optimalValue: 7 },
          { precireResult: 'Authoritative', optimalValue: 9 },
          { precireResult: 'Impressive', optimalValue: 8 },
          { precireResult: 'Impulsive', optimalValue: 3 },
          { precireResult: 'Optimistic', optimalValue: 8 },
          { precireResult: 'Philosophical', optimalValue: 6 },
          { precireResult: 'Dramatic', optimalValue: 3 },
          { precireResult: 'Unconventional', optimalValue: 7 },
          { precireResult: 'Motivating', optimalValue: 8 },
          { precireResult: 'Friendly', optimalValue: 8 },
          { precireResult: 'Composed', optimalValue: 9 },
        ],
        'Accounting/Finance': [
          { precireResult: 'Positive', optimalValue: 6 },
          { precireResult: 'Reliable', optimalValue: 10 },
          { precireResult: 'Supportive', optimalValue: 7 },
          { precireResult: 'Professional', optimalValue: 10 },
          { precireResult: 'Directing', optimalValue: 6 },
          { precireResult: 'Formal', optimalValue: 9 },
          { precireResult: 'Cooperative', optimalValue: 7 },
          { precireResult: 'Intellectual', optimalValue: 8 },
          { precireResult: 'Competitive', optimalValue: 4 },
          { precireResult: 'Self Confident', optimalValue: 8 },
          { precireResult: 'Empathic', optimalValue: 6 },
          { precireResult: 'Structured', optimalValue: 10 },
          { precireResult: 'Venturing', optimalValue: 6 },
          { precireResult: 'Independent', optimalValue: 8 },
          { precireResult: 'Visionary', optimalValue: 7 },
          { precireResult: 'Innovative', optimalValue: 7 },
          { precireResult: 'Aggressive', optimalValue: 2 },
          { precireResult: 'Goal Oriented', optimalValue: 10 },
          { precireResult: 'Inspiring', optimalValue: 6 },
          { precireResult: 'Authoritative', optimalValue: 9 },
          { precireResult: 'Impressive', optimalValue: 7 },
          { precireResult: 'Impulsive', optimalValue: 3 },
          { precireResult: 'Optimistic', optimalValue: 7 },
          { precireResult: 'Philosophical', optimalValue: 5 },
          { precireResult: 'Dramatic', optimalValue: 3 },
          { precireResult: 'Unconventional', optimalValue: 4 },
          { precireResult: 'Motivating', optimalValue: 7 },
          { precireResult: 'Friendly', optimalValue: 7 },
          { precireResult: 'Composed', optimalValue: 9 },
        ],
        Law: [
          { precireResult: 'Positive', optimalValue: 8 },
          { precireResult: 'Reliable', optimalValue: 9 },
          { precireResult: 'Supportive', optimalValue: 9 },
          { precireResult: 'Professional', optimalValue: 10 },
          { precireResult: 'Directing', optimalValue: 8 },
          { precireResult: 'Formal', optimalValue: 9 },
          { precireResult: 'Cooperative', optimalValue: 8 },
          { precireResult: 'Intellectual', optimalValue: 10 },
          { precireResult: 'Competitive', optimalValue: 7 },
          { precireResult: 'Self Confident', optimalValue: 9 },
          { precireResult: 'Empathic', optimalValue: 7 },
          { precireResult: 'Structured', optimalValue: 10 },
          { precireResult: 'Venturing', optimalValue: 4 },
          { precireResult: 'Independent', optimalValue: 8 },
          { precireResult: 'Visionary', optimalValue: 6 },
          { precireResult: 'Innovative', optimalValue: 8 },
          { precireResult: 'Aggressive', optimalValue: 3 },
          { precireResult: 'Goal Oriented', optimalValue: 9 },
          { precireResult: 'Inspiring', optimalValue: 9 },
          { precireResult: 'Authoritative', optimalValue: 9 },
          { precireResult: 'Impressive', optimalValue: 9 },
          { precireResult: 'Impulsive', optimalValue: 3 },
          { precireResult: 'Optimistic', optimalValue: 8 },
          { precireResult: 'Philosophical', optimalValue: 8 },
          { precireResult: 'Dramatic', optimalValue: 5 },
          { precireResult: 'Unconventional', optimalValue: 7 },
          { precireResult: 'Motivating', optimalValue: 9 },
          { precireResult: 'Friendly', optimalValue: 8 },
          { precireResult: 'Composed', optimalValue: 7 },
        ],
        'Editorial/Documentation': [
          { precireResult: 'Positive', optimalValue: 8 },
          { precireResult: 'Reliable', optimalValue: 10 },
          { precireResult: 'Supportive', optimalValue: 8 },
          { precireResult: 'Professional', optimalValue: 9 },
          { precireResult: 'Directing', optimalValue: 7 },
          { precireResult: 'Formal', optimalValue: 8 },
          { precireResult: 'Cooperative', optimalValue: 9 },
          { precireResult: 'Intellectual', optimalValue: 8 },
          { precireResult: 'Competitive', optimalValue: 5 },
          { precireResult: 'Self Confident', optimalValue: 9 },
          { precireResult: 'Empathic', optimalValue: 9 },
          { precireResult: 'Structured', optimalValue: 8 },
          { precireResult: 'Venturing', optimalValue: 8 },
          { precireResult: 'Independent', optimalValue: 10 },
          { precireResult: 'Visionary', optimalValue: 8 },
          { precireResult: 'Innovative', optimalValue: 7 },
          { precireResult: 'Aggressive', optimalValue: 4 },
          { precireResult: 'Goal Oriented', optimalValue: 9 },
          { precireResult: 'Inspiring', optimalValue: 8 },
          { precireResult: 'Authoritative', optimalValue: 9 },
          { precireResult: 'Impressive', optimalValue: 8 },
          { precireResult: 'Impulsive', optimalValue: 6 },
          { precireResult: 'Optimistic', optimalValue: 9 },
          { precireResult: 'Philosophical', optimalValue: 7 },
          { precireResult: 'Dramatic', optimalValue: 7 },
          { precireResult: 'Unconventional', optimalValue: 8 },
          { precireResult: 'Motivating', optimalValue: 8 },
          { precireResult: 'Friendly', optimalValue: 8 },
          { precireResult: 'Composed', optimalValue: 9 },
        ],
        'Security/Civil Protection': [
          { precireResult: 'Positive', optimalValue: 5 },
          { precireResult: 'Reliable', optimalValue: 10 },
          { precireResult: 'Supportive', optimalValue: 9 },
          { precireResult: 'Professional', optimalValue: 9 },
          { precireResult: 'Directing', optimalValue: 9 },
          { precireResult: 'Formal', optimalValue: 7 },
          { precireResult: 'Cooperative', optimalValue: 9 },
          { precireResult: 'Intellectual', optimalValue: 7 },
          { precireResult: 'Competitive', optimalValue: 5 },
          { precireResult: 'Self Confident', optimalValue: 9 },
          { precireResult: 'Empathic', optimalValue: 7 },
          { precireResult: 'Structured', optimalValue: 10 },
          { precireResult: 'Venturing', optimalValue: 3 },
          { precireResult: 'Independent', optimalValue: 7 },
          { precireResult: 'Visionary', optimalValue: 3 },
          { precireResult: 'Innovative', optimalValue: 6 },
          { precireResult: 'Aggressive', optimalValue: 5 },
          { precireResult: 'Goal Oriented', optimalValue: 10 },
          { precireResult: 'Inspiring', optimalValue: 8 },
          { precireResult: 'Authoritative', optimalValue: 7 },
          { precireResult: 'Impressive', optimalValue: 7 },
          { precireResult: 'Impulsive', optimalValue: 4 },
          { precireResult: 'Optimistic', optimalValue: 6 },
          { precireResult: 'Philosophical', optimalValue: 3 },
          { precireResult: 'Dramatic', optimalValue: 5 },
          { precireResult: 'Unconventional', optimalValue: 7 },
          { precireResult: 'Motivating', optimalValue: 8 },
          { precireResult: 'Friendly', optimalValue: 9 },
          { precireResult: 'Composed', optimalValue: 9 },
        ],
        'Distribution/Sales': [
          { precireResult: 'Positive', optimalValue: 9 },
          { precireResult: 'Reliable', optimalValue: 8 },
          { precireResult: 'Supportive', optimalValue: 7 },
          { precireResult: 'Professional', optimalValue: 9 },
          { precireResult: 'Directing', optimalValue: 8 },
          { precireResult: 'Formal', optimalValue: 7 },
          { precireResult: 'Cooperative', optimalValue: 9 },
          { precireResult: 'Intellectual', optimalValue: 7 },
          { precireResult: 'Competitive', optimalValue: 8 },
          { precireResult: 'Self Confident', optimalValue: 9 },
          { precireResult: 'Empathic', optimalValue: 9 },
          { precireResult: 'Structured', optimalValue: 7 },
          { precireResult: 'Venturing', optimalValue: 8 },
          { precireResult: 'Independent', optimalValue: 9 },
          { precireResult: 'Visionary', optimalValue: 8 },
          { precireResult: 'Innovative', optimalValue: 8 },
          { precireResult: 'Aggressive', optimalValue: 4 },
          { precireResult: 'Goal Oriented', optimalValue: 9 },
          { precireResult: 'Inspiring', optimalValue: 9 },
          { precireResult: 'Authoritative', optimalValue: 9 },
          { precireResult: 'Impressive', optimalValue: 8 },
          { precireResult: 'Impulsive', optimalValue: 5 },
          { precireResult: 'Optimistic', optimalValue: 9 },
          { precireResult: 'Philosophical', optimalValue: 7 },
          { precireResult: 'Dramatic', optimalValue: 6 },
          { precireResult: 'Unconventional', optimalValue: 8 },
          { precireResult: 'Motivating', optimalValue: 9 },
          { precireResult: 'Friendly', optimalValue: 8 },
          { precireResult: 'Composed', optimalValue: 7 },
        ],
      }
    },
    $recommendedPrecireValues() {
      return [
        {
          precireResult: 'empathic',
          optimalValue: 4,
        },
        {
          precireResult: 'friendly',
          optimalValue: 4,
        },
        {
          precireResult: 'supportive',
          optimalValue: 4,
        },
        {
          precireResult: 'positive',
          optimalValue: 4,
        },
        {
          precireResult: 'optimistic',
          optimalValue: 4,
        },
        {
          precireResult: 'visionary',
          optimalValue: 4,
        },
        {
          precireResult: 'formal',
          optimalValue: 4,
        },
        {
          precireResult: 'structured',
          optimalValue: 4,
        },
        {
          precireResult: 'goal-oriented',
          optimalValue: 4,
        },
        {
          precireResult: 'goal_oriented',
          optimalValue: 4,
        },
        {
          precireResult: 'reliable',
          optimalValue: 4,
        },
        {
          precireResult: 'intellectual',
          optimalValue: 4,
        },
        {
          precireResult: 'unconventional',
          optimalValue: 4,
        },
        {
          precireResult: 'philosophical',
          optimalValue: 4,
        },
        {
          precireResult: 'impulsive',
          optimalValue: 4,
        },
        {
          precireResult: 'aggressive',
          optimalValue: 4,
        },
        {
          precireResult: 'authoritative',
          optimalValue: 4,
        },
        {
          precireResult: 'self-confident',
          optimalValue: 4,
        },
        {
          precireResult: 'self_confident',
          optimalValue: 4,
        },
        {
          precireResult: 'composed',
          optimalValue: 4,
        },
        {
          precireResult: 'dramatic',
          optimalValue: 4,
        },
        {
          precireResult: 'motivating',
          optimalValue: 4,
        },
        {
          precireResult: 'impressive',
          optimalValue: 4,
        },
        {
          precireResult: 'independent',
          optimalValue: 4,
        },
        {
          precireResult: 'cooperative',
          optimalValue: 4,
        },
        {
          precireResult: 'venturing',
          optimalValue: 4,
        },
        {
          precireResult: 'professional',
          optimalValue: 4,
        },
        {
          precireResult: 'innovative',
          optimalValue: 4,
        },
        {
          precireResult: 'competitive',
          optimalValue: 4,
        },
        {
          precireResult: 'directing',
          optimalValue: 4,
        },
        {
          precireResult: 'dramatic',
          optimalValue: 4,
        },
        {
          precireResult: 'inspiring',
          optimalValue: 4,
        },
        {
          precireResult: 'independent',
          optimalValue: 4,
        },
      ]
    },
  },
  methods: {
    isObjectEmpty(obj) {
      return obj && !Object.keys(obj).length
    },
    // Platform Detection
    isIos() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    },
    isAndroid() {
      return /Android/i.test(navigator.userAgent)
    },
    // Browser Detection
    isSafari() {
      // return window.safari !== undefined
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    },
    isSafariIos() {
      var ua = window.navigator.userAgent
      var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i)
      var webkit = !!ua.match(/WebKit/i)
      var iOSSafari = iOS && webkit && !ua.match(/CriOS/i)
      return iOSSafari
    },
    isMobileAndroid() {
      return this.isAndroid() && this.isMobileWidth()
    },
    isMobileIos() {
      return this.isIos() && this.isMobileWidth()
    },
    isMobileWidth() {
      return window && window.innerWidth <= 576
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
        navigator.userAgent
      )
    },
    isAllMobile(width) {
      return (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
          navigator.userAgent
        ) && window.innerWidth <= (575 || width)
      )
    },
    setUserProps(user) {
      // fix this dumbass code, use vuex persist
      // localStorage.setItem('userType', user.userType)
      // localStorage.setItem('userEmail', user.email)
      this.$userType = localStorage.getItem('userType')
      this.$userEmail = localStorage.getItem('userEmail')
      this.$isRecruiter = localStorage.getItem('userType') === 'Recruiter'
      this.$isCandidate = localStorage.getItem('userType') === 'Candidate'
      this.$isAdmin = localStorage.getItem('userType') === 'User'
    },
    showGenericValidationError() {
      this.$swal({
        icon: 'error',
        title: this.$i18n.translate('Error'),
        text: this.$i18n.translate('Please correct errors before proceeding'),
        confirmButtonColor: '#35A49D',
        customClass: {
          icon: 'wr-success-class',
        },
      })
    },
    showGenericError({ title, text, html }) {
      this.$swal({
        icon: 'error',
        title: this.$i18n.translate(title),
        text: this.$i18n.translate(text),
        html: this.$i18n.translate(html),
        confirmButtonColor: '#35A49D',
        customClass: {
          icon: 'wr-success-class',
        },
      })
    },
    showGenericWarning({ title, text, html }) {
      return this.$swal({
        icon: 'warning',
        // title: !title ? this.$i18n.translate('Error') : title,
        title: this.$i18n.translate(title),
        text: this.$i18n.translate(text),
        html: this.$i18n.translate(html),
        confirmButtonColor: '#35A49D',
        customClass: {
          icon: 'wr-success-class',
        },
      })
    },
    showGenericSuccess({ title, text }) {
      return this.$swal({
        icon: 'success',
        title: this.$i18n.translate(title),
        text: this.$i18n.translate(text),
        confirmButtonColor: '#35A49D',
        customClass: {
          icon: 'wr-success-class',
        },
      })
    },
    showGenericInfo({ title, text, html, width, btnColor = '#FABC60', imgUrl = undefined }) {
      let options = {
        icon: 'info',
        width,
        title: this.$i18n.translate(title),
        text: this.$i18n.translate(text),
        html: this.$i18n.translate(html),
        confirmButtonColor: btnColor,
        customClass: {
          icon: 'wr-success-class',
        },
      }
      if (imgUrl) {
        delete options.icon
        delete options.width
        options.imageUrl = imgUrl
        options.imageWidth = 100
        options.imageHeight = 100
      }
      return this.$swal(options)
    },
    showQuestionDialog(icon, title, desc, cnfBtn, cancBtn, reverse, callback) {
      this.$swal({
        icon,
        title: this.$i18n.translate(title),
        html: this.$i18n.translate(desc),
        showCancelButton: true,
        confirmButtonColor: '#35A49D',
        cancelButtonColor: '#FABC60',
        confirmButtonText: this.$i18n.translate(cnfBtn),
        cancelButtonText: this.$i18n.translate(cancBtn),
        reverseButtons: reverse,
        customClass: {
          icon: 'wr-success-class',
        },
      }).then(callback)
    },
    showAsyncQuestionDialog({
      icon,
      title,
      desc,
      confirmBtn,
      cancelBtn,
      denyBtn,
      reverse,
      reverseColor,
    }) {
      return this.$swal({
        icon,
        title: this.$i18n.translate(title),
        html: this.$i18n.translate(desc),
        showCancelButton: cancelBtn ? true : false,
        showDenyButton: denyBtn ? true : false,
        confirmButtonColor: reverseColor ? '#FABC60' : '#35A49D', //
        denyButtonColor: '#FABC60', // '#248291', old metru green
        cancelButtonColor: reverseColor ? '#35A49D' : '#FABC60',
        confirmButtonText: this.$i18n.translate(confirmBtn),
        cancelButtonText: this.$i18n.translate(cancelBtn),
        denyButtonText: this.$i18n.translate(denyBtn),
        reverseButtons: reverse,
        customClass: {
          icon: 'wr-success-class',
        },
      })
    },
    notification(text, action = {}) {
      this.$toasted.show(text, action)
    },
    copied() {
      this.notification(this.$i18n.translate('Copied'))
    },
    audioVideoCapture(success, error, mode) {
      // navigator.getUserMedia =
      //   navigator.getUserMedia ||
      //   navigator.webkitGetUserMedia ||
      //   navigator.mozGetUserMedia ||
      //   navigator.msGetUserMedia
      navigator.mediaDevices
        .getUserMedia(mode === 'portrait' ? this.portraitConstraints : this.landscapeContraints)
        .then(camera => {
          success(camera)
        })
        .catch(err => {
          error(err)
        })
    },
    stopAudioVideoCapture(cameraStream) {
      return cameraStream.getTracks().forEach(track => track.stop())
    },
    changeAppLanguage(lang, paramName) {
      let paraName = this.$route.name || paramName
      const localStorageLang = getCookieValue('lang')
      if (lang) {
        console.log('lang: ', lang)
        this.currentLanguage = lang
      } else {
        const langQueryParam = this.$route.query.lang
        const browserLang = navigator.language.split('-')[0]
        this.currentLanguage = langQueryParam || localStorageLang || browserLang
      }
      document.cookie = `lang=${this.currentLanguage}`
      this.$i18n.set(this.currentLanguage)
      // update request headers to allow backend to send mails in the language prefered by the user
      setAxiosHeaderAcceptLang(this.currentLanguage)
      Validator.localize(
        this.currentLanguage,
        this.currentLanguage === 'en' ? en : this.currentLanguage === 'de' ? de : en
      )
      if (!paraName) return
      if (paraName.includes('video-interview') || paraName.includes('job-interview')) return
      if (lang) {
        // location.reload()
        this.$router.go(0)
      }
    },
    parseTranslation(string, toReplace, replacement) {
      if (!string.includes(toReplace)) return string
      return string.replace(toReplace, replacement)
    },
    parseErrorMsg(word) {
      if (!word) return ''
      // make sure the separator is - . e.g: jobcode-title which most likely is also going to be placed in 'name' attribute of html elements
      return word.replace(/-/g, ' ')
    },
    toastNotification(type, title, message, useHtml) {
      this.$notify({
        type: type,
        title: this.$i18n.translate(title),
        message: this.$i18n.translate(message),
        dangerouslyUseHTMLString: useHtml || false,
      })
    },
    defaultStyles() {
      document.body.style.setProperty('--color-green3', '#248291')
      document.body.style.setProperty('--color-orange', '#FABC60')
      document.body.style.setProperty('--font-style', `'Lato', sans-serif`)
    },
    applyCIStyles(companyProps) {
      if (companyProps) {
        this.$store.dispatch('adminPanelModule/setCICompanyInfo', companyProps)
      }
      if (localStorage.getItem('corporateIdentityInfo')) {
        let companyStyles = JSON.parse(
          localStorage.getItem('corporateIdentityInfo')
        ).corporateIdentityStyleDetails

        if (companyStyles && Array.isArray(companyStyles) && companyStyles.length > 0) {
          if (companyStyles[0].fontUrl) {
            let link = document.createElement('link')
            link.setAttribute('rel', 'stylesheet')
            link.setAttribute('type', 'text/css')
            link.setAttribute('href', companyStyles[0].fontUrl)
            document.head.appendChild(link)
          }
		  // only set --font-style prop if fontStyle from response is present
          if (companyStyles[0].fontStyle) {
            document.body.style.setProperty('--font-style', companyStyles[0].fontStyle)
          }
          document.body.style.setProperty('--color-green3', companyStyles[0].primaryColor1)
          document.body.style.setProperty('--color-orange', companyStyles[0].secondaryColor1)
        } else {
          this.defaultStyles()
        }
      } else {
        this.defaultStyles()
      }
    },
    removeCIStyles() {
      this.$store.dispatch('adminPanelModule/setCICompanyInfo') // without second parameter it removes the CI data
      this.defaultStyles()
    },
  },
}
